export type ContentType = "carousel" | "image" | "video" | "ai" | "print";
export type GoalType = "Engagement" | "Sales" | "Awareness";

export interface Project {
  id: string;
  slug: string;
  type: ContentType;
  title: string;
  client: string;
  category: "Visual" | "Print" | "Reels" | "AI";
  thumbnail: string;
  coverImage: string;
  slides?: string[];
  videoSrc?: string;
  images: string[];
  description: string;
  services: string[];
  goal?: GoalType;
  results?: { value: string; label: string }[];
  year?: string;
}

// ─── Carousels (category: Designs) ───────────────────────────────────────────

const carousels: Project[] = [
  {
    id: "c50",
    slug: "fine-design-kambanite-gardens",
    type: "carousel",
    title: "Fine Design × Kambanite Gardens - Exclusive Interior Partner",
    client: "Fine Design",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/50/1.webp",
    coverImage: "/work/CAROUSELS/50/1.webp",
    slides: [
      "/work/CAROUSELS/50/1.webp",
      "/work/CAROUSELS/50/2.webp",
      "/work/CAROUSELS/50/3.webp",
      "/work/CAROUSELS/50/4.webp",
      "/work/CAROUSELS/50/5.webp",
      "/work/CAROUSELS/50/6.webp",
      "/work/CAROUSELS/50/7.webp",
      "/work/CAROUSELS/50/8.webp",
      "/work/CAROUSELS/50/9.webp",
    ],
    images: ["/work/CAROUSELS/50/1.webp"],
    description:
      'A 9-slide partnership carousel announcing Fine Design as the exclusive design and renovation partner of Kambanite Gardens, a gated neighbourhood at the foot of Vitosha. Opening on "Outside Kambanite Gardens. Inside Fine Design.", it walks future owners through the full service, the portfolio, 3D render vs. reality and a build timeline, arguing for starting the interior before Act 16, and closes with a booking CTA.',
    services: ["Campaign Concept", "Copywriting", "Graphic Design"],
    goal: "Sales",
    year: "2026",
  },
  {
    id: "c47",
    slug: "smart-strips-aftr-party-poolside",
    type: "carousel",
    title: "Smart Strips AFTR PARTY - Poolside Recovery Campaign",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/47/1.webp",
    coverImage: "/work/CAROUSELS/47/1.webp",
    slides: [
      "/work/CAROUSELS/47/1.webp",
      "/work/CAROUSELS/47/2.webp",
      "/work/CAROUSELS/47/3.webp",
      "/work/CAROUSELS/47/4.webp",
      "/work/CAROUSELS/47/5.webp",
      "/work/CAROUSELS/47/6.webp",
    ],
    images: ["/work/CAROUSELS/47/1.webp"],
    description:
      "A six-slide summer campaign for AFTR PARTY shot around a pool with a striped float. Each slide carries one idea - better mornings, the two key ingredients (milk thistle and tyrosine), what a strip is, the before-bed and next-morning ritual and the bioavailability numbers - so the product explains itself while the imagery keeps the mood aspirational.",
    services: ["Art Direction", "Copywriting", "Graphic Design"],
    goal: "Sales",
    year: "2026",
  },
  {
    id: "c49",
    slug: "sallina-hongqi-brand-intro",
    type: "carousel",
    title: "Hongqi - Meet the Brand at Sallina",
    client: "Салина × Hongqi",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/49/1.webp",
    coverImage: "/work/CAROUSELS/49/1.webp",
    slides: [
      "/work/CAROUSELS/49/1.webp",
      "/work/CAROUSELS/49/2.webp",
      "/work/CAROUSELS/49/3.webp",
      "/work/CAROUSELS/49/4.webp",
      "/work/CAROUSELS/49/5.webp",
      "/work/CAROUSELS/49/6.webp",
      "/work/CAROUSELS/49/7.webp",
      "/work/CAROUSELS/49/8.webp",
    ],
    images: ["/work/CAROUSELS/49/1.webp"],
    description:
      'An eight-slide launch carousel introducing Hongqi to the Sallina showroom in Plovdiv. Dark, premium layouts with red accents answer "Which brand is Hongqi?" - from its 1958 "Red Flag" origins to the H9 and H5 sedans, the HS5 and HS3 SUVs, standard equipment and the "Wings of Hongqi" light projection - before ending on a "coming soon" call to get in touch.',
    services: ["Brand Storytelling", "Copywriting", "Graphic Design"],
    goal: "Awareness",
    year: "2026",
  },
  {
    id: "c48",
    slug: "coolfit-executive-hr-retreat",
    type: "carousel",
    title: "CoolFit - Executive HR Retreat 2026",
    client: "CoolFit",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/48/1.webp",
    coverImage: "/work/CAROUSELS/48/1.webp",
    slides: [
      "/work/CAROUSELS/48/1.webp",
      "/work/CAROUSELS/48/2.webp",
      "/work/CAROUSELS/48/3.webp",
      "/work/CAROUSELS/48/4.webp",
      "/work/CAROUSELS/48/5.webp",
      "/work/CAROUSELS/48/6.webp",
    ],
    images: ["/work/CAROUSELS/48/1.webp"],
    description:
      'A six-slide Meta Ads carousel for the Executive HR Retreat 2026, organised by CoolFit and Fit Kit with Forbes Bulgaria as media partner. Navy and gold editorial layouts move from the hook "The Balkans need more conversations like this" through the idea, programme, experience and venue - Grand Hotel Therme in Banya - to who it is for and an early-bird "Reserve your place" CTA.',
    services: ["Event Marketing", "Meta Ads", "Copywriting", "Graphic Design"],
    goal: "Sales",
    year: "2026",
  },
  {
    id: "c44",
    slug: "smart-strips-oral-delivery-science",
    type: "carousel",
    title: "Smart Strips - Why Oral Delivery Works",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/44/1.webp",
    coverImage: "/work/CAROUSELS/44/1.webp",
    slides: [
      "/work/CAROUSELS/44/1.webp",
      "/work/CAROUSELS/44/2.webp",
      "/work/CAROUSELS/44/3.webp",
      "/work/CAROUSELS/44/4.webp",
      "/work/CAROUSELS/44/5.webp",
    ],
    images: ["/work/CAROUSELS/44/1.webp"],
    description:
      'A five-slide educational carousel in black and gold. It opens on "Most of what you swallow never reaches your blood", lays out the four barriers a pill has to survive, shows how the oral mucosa skips all of them, backs the claim with the 95% / 35% / 30% numbers and ends on the strip technology itself - science content that reads like a luxury brand.',
    services: ["Product Education", "Copywriting", "Art Direction", "Graphic Design"],
    goal: "Awareness",
    year: "2026",
  },
  {
    id: "c51",
    slug: "fine-design-retro-car-museum",
    type: "carousel",
    title: "Fine Design - Retro Car Museum in The Building",
    client: "Fine Design",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/51/1.webp",
    coverImage: "/work/CAROUSELS/51/1.webp",
    slides: [
      "/work/CAROUSELS/51/1.webp",
      "/work/CAROUSELS/51/2.webp",
      "/work/CAROUSELS/51/3.webp",
    ],
    images: ["/work/CAROUSELS/51/1.webp"],
    description:
      'A press carousel for Fine Design\'s interior of the Retro Car Museum at SPA Hotel Markovo, as published in The Building magazine. The cover frames the vintage cars under the sculpted ceiling, and the next two slides unpack the concept - "design as storyteller" and "light as an instrument" - turning a magazine feature into proof of the studio\'s range beyond homes.',
    services: ["PR Content", "Copywriting", "Graphic Design"],
    goal: "Awareness",
    year: "2026",
  },
  {
    id: "c46",
    slug: "smart-strips-sleep-and-skin",
    type: "carousel",
    title: "Smart Strips - How Bad Sleep Derails Good Skin",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/46/1.webp",
    coverImage: "/work/CAROUSELS/46/1.webp",
    slides: [
      "/work/CAROUSELS/46/1.webp",
      "/work/CAROUSELS/46/2.webp",
      "/work/CAROUSELS/46/3.webp",
      "/work/CAROUSELS/46/4.webp",
    ],
    images: ["/work/CAROUSELS/46/1.webp"],
    description:
      'A four-slide carousel that links sleep to skin. A model in hair rollers with a Smart Strips mug asks "How bad sleep derails good skin?", soft beige slides explain that skin repairs itself overnight and that "tired skin" is an unfinished repair cycle, and the close pairs Z-z-Zen with Beauté: "Two strips. One ritual."',
    services: ["Product Education", "Copywriting", "Graphic Design"],
    goal: "Engagement",
    year: "2026",
  },
  {
    id: "c45",
    slug: "smart-strips-dissolving-vitamins",
    type: "carousel",
    title: "Smart Strips - Americans Are Dissolving Their Vitamins",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/45/1.webp",
    coverImage: "/work/CAROUSELS/45/1.webp",
    slides: [
      "/work/CAROUSELS/45/1.webp",
      "/work/CAROUSELS/45/2.webp",
      "/work/CAROUSELS/45/3.webp",
    ],
    images: ["/work/CAROUSELS/45/1.webp"],
    description:
      'A three-slide trend carousel led by the hook "Americans are no longer swallowing their vitamins. They\'re dissolving them." A bold editorial shot of a model between two zebras stops the scroll, then the NMN strip slides explain why oral strips work better and how much faster they absorb.',
    services: ["Hook-Based Copywriting", "Art Direction", "Graphic Design"],
    goal: "Awareness",
    year: "2026",
  },
  {
    id: "c1",
    slug: "carousel-1",
    type: "carousel",
    title: "Why Your Supplements Aren't Working",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/1/6.webp",
    coverImage: "/work/CAROUSELS/1/6.webp",
    slides: [
      "/work/CAROUSELS/1/6.webp",
      "/work/CAROUSELS/1/7.webp",
      "/work/CAROUSELS/1/8.webp",
      "/work/CAROUSELS/1/9.webp",
      "/work/CAROUSELS/1/10.webp",
      "/work/CAROUSELS/1/11.webp",
    ],
    images: ["/work/CAROUSELS/1/6.webp"],
    description:
      "A problem-awareness carousel for Smart Strips built around the hook \"4 reasons why your supplements aren't working.\" Shot with a model dissolving a strip on her tongue, it challenges existing supplement habits and positions the brand's bioavailable oral strips as the superior delivery method.",
    services: ["Hook-Based Copywriting", "Graphic Design", "Product Education"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "c2",
    slug: "carousel-2",
    type: "carousel",
    title: "The Best Nights Deserve a Better Morning",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/2/13.webp",
    coverImage: "/work/CAROUSELS/2/13.webp",
    slides: [
      "/work/CAROUSELS/2/13.webp",
      "/work/CAROUSELS/2/14.webp",
      "/work/CAROUSELS/2/15.webp",
      "/work/CAROUSELS/2/16.webp",
    ],
    images: ["/work/CAROUSELS/2/13.webp"],
    description:
      "A lifestyle-forward hangover recovery carousel linking Smart Strips to post-party wellness. Shot outdoors with a glamorous model wearing grape cluster earrings, the creative uses aspirational tonality to make recovery feel luxurious rather than medicinal.",
    services: [
      "Lifestyle Photography Direction",
      "Copywriting",
      "Social Media Management",
    ],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "c3",
    slug: "carousel-3",
    type: "carousel",
    title: "Why NMN Is the Biggest Hype in Wellness",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/3/18.webp",
    coverImage: "/work/CAROUSELS/3/18.webp",
    slides: [
      "/work/CAROUSELS/3/18.webp",
      "/work/CAROUSELS/3/19.webp",
      "/work/CAROUSELS/3/20.webp",
      "/work/CAROUSELS/3/21.webp",
      "/work/CAROUSELS/3/22.webp",
    ],
    images: ["/work/CAROUSELS/3/18.webp"],
    description:
      "An authority-building educational carousel about NMN anti-aging supplements. A mature, elegant model holds the Smart Strips NMN packets to signal anti-aging relevance, while the copy builds credibility around a trending ingredient and drives organic reach through education.",
    services: [
      "Content Creation",
      "Graphic Design",
      "Influencer Art Direction",
    ],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "c5",
    slug: "carousel-5",
    type: "carousel",
    title: "The Diamond in Supplementation",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/5/1.webp",
    coverImage: "/work/CAROUSELS/5/1.webp",
    slides: [
      "/work/CAROUSELS/5/1.webp",
      "/work/CAROUSELS/5/3.webp",
      "/work/CAROUSELS/5/14.webp",
      "/work/CAROUSELS/5/16.webp",
      "/work/CAROUSELS/5/20.webp",
      "/work/CAROUSELS/5/21.webp",
    ],
    images: ["/work/CAROUSELS/5/1.webp"],
    description:
      'A premium brand-positioning carousel built around a luxury metaphor. A deep red still life featuring a wine glass with a diamond bracelet and a cherry uses strikethrough copy - "The cherry on top" replaced by "the DIAMOND in supplementation" - to reframe Smart Strips as the pinnacle of the supplement category.',
    services: ["Brand Storytelling", "Art Direction", "Graphic Design"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "c6",
    slug: "carousel-6",
    type: "carousel",
    title: "Your Anxiety Doesn't Need a Pill",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/6/15.webp",
    coverImage: "/work/CAROUSELS/6/15.webp",
    slides: [
      "/work/CAROUSELS/6/15.webp",
      "/work/CAROUSELS/6/16.webp",
      "/work/CAROUSELS/6/17.webp",
      "/work/CAROUSELS/6/18.webp",
    ],
    images: ["/work/CAROUSELS/6/15.webp"],
    description:
      'A direct, punchy carousel for Smart Strips\' calming strip. An extreme close-up of a freckled face with a strip on the tongue drives home the anti-pharma message: "Your anxiety doesn\'t need a pill. IT NEEDS A STRIP." The word "anxiety" is visually struck through to reinforce brand differentiation from traditional medication.',
    services: ["Copywriting", "Graphic Design", "Meta Ads"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c7",
    slug: "carousel-7",
    type: "carousel",
    title: "FCKN FIT Pre-Workout - Problem Solved",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/7/5.webp",
    coverImage: "/work/CAROUSELS/7/5.webp",
    slides: [
      "/work/CAROUSELS/7/5.webp",
      "/work/CAROUSELS/7/6.webp",
      "/work/CAROUSELS/7/7.webp",
      "/work/CAROUSELS/7/8.webp",
      "/work/CAROUSELS/7/9.webp",
      "/work/CAROUSELS/7/10.webp",
      "/work/CAROUSELS/7/11.webp",
      "/work/CAROUSELS/7/12.webp",
    ],
    images: ["/work/CAROUSELS/7/5.webp"],
    description:
      'A relatable problem/solution carousel for Smart Strips\' FCKN FIT pre-workout strip. Shot from behind, a fit woman in sportswear carries two yoga mats. The layout frames the universal fitness struggle - "You want to workout. Your body says later." - then delivers the product as the irreverent solution, targeting active audiences with bold brand voice.',
    services: [
      "Campaign Concept",
      "Copywriting",
      "Social Media Management",
      "Graphic Design",
    ],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "c8",
    slug: "carousel-8",
    type: "carousel",
    title: "Anti-Aging vs. Longevity - A Mindset Shift",
    client: "Dani Lekusheva Coach",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/8/1.webp",
    coverImage: "/work/CAROUSELS/8/1.webp",
    slides: [
      "/work/CAROUSELS/8/1.webp",
      "/work/CAROUSELS/8/2.webp",
      "/work/CAROUSELS/8/3.webp",
      "/work/CAROUSELS/8/4.webp",
      "/work/CAROUSELS/8/5.webp",
    ],
    images: ["/work/CAROUSELS/8/1.webp"],
    description:
      'An educational mindset-shift carousel for wellness coach Dani Lekusheva, aimed at women. The soft pink editorial design opens with "Anti-aging vs Longevity" and argues: "Stop fighting aging. Start building longevity." It contrasts outdated anti-aging thinking with longevity as a sustainable lifestyle philosophy, building authority in the wellness space.',
    services: [
      "Content Creation",
      "Copywriting",
      "Art Direction",
      "Graphic Design",
    ],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "c9",
    slug: "carousel-9",
    type: "carousel",
    title: "4 Mistakes When Choosing a New Car",
    client: "Салина × Dongfeng",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/9/1.webp",
    coverImage: "/work/CAROUSELS/9/1.webp",
    slides: [
      "/work/CAROUSELS/9/1.webp",
      "/work/CAROUSELS/9/2.webp",
      "/work/CAROUSELS/9/3.webp",
      "/work/CAROUSELS/9/4.webp",
      "/work/CAROUSELS/9/5.webp",
      "/work/CAROUSELS/9/6.webp",
    ],
    images: ["/work/CAROUSELS/9/1.webp"],
    description:
      'A co-branded educational hook carousel for Салина dealership and Dongfeng. Shot with a dark SUV on a highway, the bold Bulgarian headline - "4 ГРЕШКИ ПРИ ИЗБОРА НА НОВ АВТОМОБИЛ" - uses a common-mistake format to attract car buyers organically, positioning the dealership as a trusted advisor before the sale.',
    services: ["Content Creation", "Copywriting", "Graphic Design"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "c10",
    slug: "carousel-10",
    type: "carousel",
    title: "El Shisha Diamond - Premium Product Launch",
    client: "El Shisha Diamond",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/10/1.webp",
    coverImage: "/work/CAROUSELS/10/1.webp",
    slides: [
      "/work/CAROUSELS/10/1.webp",
      "/work/CAROUSELS/10/37.webp",
      "/work/CAROUSELS/10/47.webp",
      "/work/CAROUSELS/10/48.webp",
    ],
    images: ["/work/CAROUSELS/10/1.webp"],
    description:
      "A luxury product launch carousel for the El Shisha Diamond limited edition disposable vapes. Four designer-wrapped devices in distinct patterns (graffiti, houndstooth, carbon fiber, art print) are displayed on a gold-geometric background. Specs and flavor variants are listed with a premium fashion-house aesthetic to position the product as collectible.",
    services: ["Product Launch Campaign", "Art Direction", "Graphic Design"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c11",
    slug: "carousel-11",
    type: "carousel",
    title: "Fine Design - Turnkey Renovation Management",
    client: "Fine Design",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/11/1.webp",
    coverImage: "/work/CAROUSELS/11/1.webp",
    slides: [
      "/work/CAROUSELS/11/1.webp",
      "/work/CAROUSELS/11/2.webp",
      "/work/CAROUSELS/11/3.webp",
      "/work/CAROUSELS/11/4.webp",
      "/work/CAROUSELS/11/5.webp",
      "/work/CAROUSELS/11/6.webp",
      "/work/CAROUSELS/11/7.webp",
    ],
    images: ["/work/CAROUSELS/11/1.webp"],
    description:
      'A service-education carousel for Fine Design interior studio. A professional designer stands in an unfinished apartment holding a tablet with the 3D render, construction workers visible behind her. The copy - "A renovation you don\'t manage. A result we control." - positions Fine Design as a full turnkey renovation manager for discerning clients.',
    services: [
      "Social Media Management",
      "Copywriting",
      "Graphic Design",
      "Content Creation",
    ],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "c12",
    slug: "carousel-12",
    type: "carousel",
    title: "Dongfeng Shine - Model Reveal",
    client: "Салина × Dongfeng",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/12/1.webp",
    coverImage: "/work/CAROUSELS/12/1.webp",
    slides: [
      "/work/CAROUSELS/12/1.webp",
      "/work/CAROUSELS/12/8.webp",
      "/work/CAROUSELS/12/9.webp",
      "/work/CAROUSELS/12/11.webp",
    ],
    images: ["/work/CAROUSELS/12/1.webp"],
    description:
      "An aspirational product reveal carousel for the Dongfeng Shine sedan. The model name appears in massive white typography behind a silver sports sedan driving at golden hour. Key specs (sports car, 4 doors, 190 hp) are listed alongside the Салина dealership badge, creating a cinematic launch feel for the Bulgarian market.",
    services: ["Graphic Design", "Art Direction", "Meta Ads"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "c13",
    slug: "carousel-13",
    type: "carousel",
    title: "Trio House - Boutique Townhouse Project",
    client: "Trio House",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/13/1.webp",
    coverImage: "/work/CAROUSELS/13/1.webp",
    slides: [
      "/work/CAROUSELS/13/1.webp",
      "/work/CAROUSELS/13/2.webp",
      "/work/CAROUSELS/13/4.webp",
      "/work/CAROUSELS/13/10.webp",
      "/work/CAROUSELS/13/11.webp",
      "/work/CAROUSELS/13/12.webp",
    ],
    images: ["/work/CAROUSELS/13/1.webp"],
    description:
      "A real estate sales carousel for Trio House - a boutique development of 3 townhouses with private yards in Kardzhali. Three CGI exterior renders of adjacent multi-storey homes are presented with unit B highlighted, alongside a full spec breakdown (3 bedrooms, garage, 4 floors) and direct-from-developer messaging to drive qualified leads.",
    services: ["Real Estate Marketing", "Graphic Design", "Meta Ads"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c14",
    slug: "carousel-14",
    type: "carousel",
    title: "Benefit Sport Card - Invest in Your Team",
    client: "Benefit Sport Card",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/14/1.webp",
    coverImage: "/work/CAROUSELS/14/1.webp",
    slides: [
      "/work/CAROUSELS/14/1.webp",
      "/work/CAROUSELS/14/4.webp",
      "/work/CAROUSELS/14/5.webp",
      "/work/CAROUSELS/14/7.webp",
      "/work/CAROUSELS/14/10.webp",
      "/work/CAROUSELS/14/11.webp",
    ],
    images: ["/work/CAROUSELS/14/1.webp"],
    description:
      'A seasonal B2B campaign carousel targeting HR managers and employers for Benefit Sport Card. A lifestyle collage of tennis, swimming, gym, yoga and spa activities surrounds a QR code for a free trial. The spring-themed headline - "Invest in your team\'s health this spring!" - drives corporate sign-ups with a wellness-forward employee benefits angle.',
    services: [
      "B2B Content Creation",
      "Graphic Design",
      "Social Media Management",
    ],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c15",
    slug: "carousel-15",
    type: "carousel",
    title: "Fine Design - 3D Render vs. Reality",
    client: "Fine Design",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/15/1.webp",
    coverImage: "/work/CAROUSELS/15/1.webp",
    slides: [
      "/work/CAROUSELS/15/1.webp",
      "/work/CAROUSELS/15/2.webp",
      "/work/CAROUSELS/15/8.webp",
    ],
    images: ["/work/CAROUSELS/15/1.webp"],
    description:
      "A precision proof-of-quality carousel for Fine Design. Split frames show the 3D kitchen render on top and the completed real interior below - nearly identical - demonstrating the studio's ability to deliver exactly what they visualise. The concept builds trust through visual evidence rather than claims, making it highly shareable and save-worthy.",
    services: ["Content Creation", "Graphic Design", "Social Media Management"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "c16",
    slug: "carousel-16",
    type: "carousel",
    title: "Fox Academy - Permanent Eyeliner Results",
    client: "Fox Academy by Glea",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/16/1.webp",
    coverImage: "/work/CAROUSELS/16/1.webp",
    slides: [
      "/work/CAROUSELS/16/1.webp",
      "/work/CAROUSELS/16/2.webp",
      "/work/CAROUSELS/16/3.webp",
    ],
    images: ["/work/CAROUSELS/16/1.webp"],
    description:
      'A portfolio result carousel for Fox Academy permanent makeup. An extreme macro triptych of a woman\'s eyes showcases the dramatic dark, smoky permanent eyeliner result with precise lash definition. The "AFTER" watermark and academy branding frame the post as a professional proof-of-skill that attracts both students and clients.',
    services: ["Art Direction", "Graphic Design", "Social Media Management"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "c17",
    slug: "carousel-17",
    type: "carousel",
    title: "CoolFit - How Sport Helps Creatives at Work",
    client: "CoolFit",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/17/1.webp",
    coverImage: "/work/CAROUSELS/17/1.webp",
    slides: [
      "/work/CAROUSELS/17/1.webp",
      "/work/CAROUSELS/17/2.webp",
      "/work/CAROUSELS/17/3.webp",
      "/work/CAROUSELS/17/4.webp",
    ],
    images: ["/work/CAROUSELS/17/1.webp"],
    description:
      "Part of an educational content series for CoolFit sport club targeting creative professionals - architects, designers, journalists and actors. The carousel explains how prolonged sitting harms creativity, then recommends CoolFit's dance, yoga, cycling and spa offerings as the antidote, using a hardhat-wearing professional as the persona anchor.",
    services: ["Content Creation", "Copywriting", "Graphic Design"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "c18",
    slug: "carousel-18",
    type: "carousel",
    title: "Dongfeng × Valentine's - Love Is in the Details",
    client: "Салина × Dongfeng",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/18/1.webp",
    coverImage: "/work/CAROUSELS/18/1.webp",
    slides: ["/work/CAROUSELS/18/1.webp", "/work/CAROUSELS/18/2.webp"],
    images: ["/work/CAROUSELS/18/1.webp"],
    description:
      "A seasonal Valentine's Day brand post for Салина's Dongfeng dealership. A red Dongfeng sedan with a large gift bow is staged on a cobblestone street surrounded by candles, roses and gift boxes. The elegant serif headline \"LOVE is in the details\" ties the gifting moment to the vehicle's premium feel, making the car the ultimate Valentine's gift.",
    services: ["Seasonal Campaign", "Art Direction", "Graphic Design"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "c19",
    slug: "carousel-19",
    type: "carousel",
    title: "Smart Strips Beauté - 6 Beauty Benefits",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/19/3.webp",
    coverImage: "/work/CAROUSELS/19/3.webp",
    slides: [
      "/work/CAROUSELS/19/3.webp",
      "/work/CAROUSELS/19/4.webp",
      "/work/CAROUSELS/19/5.webp",
      "/work/CAROUSELS/19/6.webp",
      "/work/CAROUSELS/19/7.webp",
      "/work/CAROUSELS/19/8.webp",
      "/work/CAROUSELS/19/9.webp",
      "/work/CAROUSELS/19/10.webp",
      "/work/CAROUSELS/19/11.webp",
      "/work/CAROUSELS/19/12.webp",
    ],
    images: ["/work/CAROUSELS/19/3.webp"],
    description:
      "An educational product benefits carousel for the Smart Strips Beauté oral beauty strip. A hot-pink pie-chart infographic divides into 6 segments - Hair Strength, Collagen Support, Nail Health, Daily Ritual, Glow Effect, Skin Elasticity - with the product centred. Designed to educate a female beauty audience and drive saves as a reference post.",
    services: [
      "Content Creation",
      "Infographic Design",
      "Social Media Management",
      "Graphic Design",
    ],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "c20",
    slug: "carousel-20",
    type: "carousel",
    title: "Fine Design - Custom Designer Wallpapers",
    client: "Fine Design",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/20/1.webp",
    coverImage: "/work/CAROUSELS/20/1.webp",
    slides: [
      "/work/CAROUSELS/20/1.webp",
      "/work/CAROUSELS/20/13.webp",
      "/work/CAROUSELS/20/18.webp",
      "/work/CAROUSELS/20/22.webp",
      "/work/CAROUSELS/20/26.webp",
    ],
    images: ["/work/CAROUSELS/20/1.webp"],
    description:
      'A service-spotlight carousel for Fine Design\'s custom photo mural offering. A moody living room render featuring a large forest-scene photo wall is framed by an elegant arch overlay. The headline "Дизайнерски фототапети по поръчка" and luxury dark palette elevate the service beyond decoration, positioning it as a signature design statement.',
    services: ["Graphic Design", "Art Direction", "Social Media Management"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c21",
    slug: "carousel-21",
    type: "carousel",
    title: "Which Dongfeng Model Is YOUR Car?",
    client: "Салина × Dongfeng",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/21/1.webp",
    coverImage: "/work/CAROUSELS/21/1.webp",
    slides: [
      "/work/CAROUSELS/21/1.webp",
      "/work/CAROUSELS/21/2.webp",
      "/work/CAROUSELS/21/3.webp",
      "/work/CAROUSELS/21/4.webp",
      "/work/CAROUSELS/21/5.webp",
      "/work/CAROUSELS/21/6.webp",
    ],
    images: ["/work/CAROUSELS/21/1.webp"],
    description:
      'An interactive quiz-style carousel for the Салина × Dongfeng range. Against a dramatic mountain road backdrop with a dark SUV, the bold Bulgarian headline asks "Which Dongfeng model is YOUR car?" - matching 5 buyer lifestyle profiles to specific models. Designed to maximise swipe-through and generate lead comments from engaged car buyers.',
    services: ["Content Creation", "Copywriting", "Graphic Design"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "c22",
    slug: "carousel-22",
    type: "carousel",
    title: "Dongfeng - 6 Safety Systems That Protect You",
    client: "Салина × Dongfeng",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/22/1.webp",
    coverImage: "/work/CAROUSELS/22/1.webp",
    slides: [
      "/work/CAROUSELS/22/1.webp",
      "/work/CAROUSELS/22/2.webp",
      "/work/CAROUSELS/22/3.webp",
      "/work/CAROUSELS/22/4.webp",
      "/work/CAROUSELS/22/5.webp",
      "/work/CAROUSELS/22/6.webp",
      "/work/CAROUSELS/22/7.webp",
    ],
    images: ["/work/CAROUSELS/22/1.webp"],
    description:
      "A technology-education carousel showcasing the Dongfeng T5 EVO's 6 integrated safety systems. Set in a futuristic showroom with holographic shield icons surrounding the vehicle, each slide breaks down a specific system with a swipe-to-learn CTA. The mock browser window aesthetic reinforces the brand's tech credentials for a Bulgarian automotive audience.",
    services: ["Content Creation", "Graphic Design", "Social Media Management"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "c23",
    slug: "carousel-23",
    type: "carousel",
    title: "How Is Dongfeng Reliability Tested?",
    client: "Салина × Dongfeng",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/23/9.webp",
    coverImage: "/work/CAROUSELS/23/9.webp",
    slides: [
      "/work/CAROUSELS/23/9.webp",
      "/work/CAROUSELS/23/10.webp",
      "/work/CAROUSELS/23/11.webp",
      "/work/CAROUSELS/23/12.webp",
      "/work/CAROUSELS/23/13.webp",
      "/work/CAROUSELS/23/14.webp",
      "/work/CAROUSELS/23/15.webp",
    ],
    images: ["/work/CAROUSELS/23/9.webp"],
    description:
      'A credibility-building carousel demystifying Dongfeng\'s quality testing process. A 3D render of a sedan on a glowing test platform, surrounded by scanning drones and rings, opens with the question "How is Dongfeng reliability tested?" The futuristic tech aesthetic translates engineering rigour into a visually engaging story for social media.',
    services: ["Art Direction", "Graphic Design", "Content Creation"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "c24",
    slug: "carousel-24",
    type: "carousel",
    title: "Why Choose a Dongfeng? - E5 SUV Reasons",
    client: "Салина × Dongfeng",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/24/32.webp",
    coverImage: "/work/CAROUSELS/24/32.webp",
    slides: [
      "/work/CAROUSELS/24/32.webp",
      "/work/CAROUSELS/24/33.webp",
      "/work/CAROUSELS/24/34.webp",
      "/work/CAROUSELS/24/35.webp",
      "/work/CAROUSELS/24/36.webp",
    ],
    images: ["/work/CAROUSELS/24/32.webp"],
    description:
      'An objection-handling sales carousel for the Dongfeng E5 SUV. A bright mountain road lifestyle scene opens with "Why choose a Dongfeng car?" and walks through key reasons to buy, each with a swipe CTA. The clean, airy aesthetic and real-world driving context appeal to aspirational buyers comparing brands in the Bulgarian market.',
    services: ["Graphic Design", "Social Media Management", "Meta Ads"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c25",
    slug: "carousel-25",
    type: "carousel",
    title: "Dongfeng Rich 6 - New Pickup on the Scene",
    client: "Салина × Dongfeng",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/25/1.webp",
    coverImage: "/work/CAROUSELS/25/1.webp",
    slides: [
      "/work/CAROUSELS/25/1.webp",
      "/work/CAROUSELS/25/6.webp",
      "/work/CAROUSELS/25/11.webp",
      "/work/CAROUSELS/25/22.webp",
      "/work/CAROUSELS/25/34.webp",
    ],
    images: ["/work/CAROUSELS/25/1.webp"],
    description:
      'A launch announcement carousel for the Dongfeng Rich 6 pickup truck. The blue hero truck is shot against a rugged desert backdrop with specs listed (4 doors, 4 seats, 160 hp). The bold reveal format - "НОВ ПИКАП НА СЦЕНАТА" - creates launch buzz with a confident, powerful tone aimed at the Bulgarian pickup truck segment.',
    services: ["Content Creation", "Graphic Design", "Meta Ads"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "c26",
    slug: "carousel-26",
    type: "carousel",
    title: "Pulse Gym Shop - Black Month Cardio Sale",
    client: "Pulse Gym Shop",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/26/1.webp",
    coverImage: "/work/CAROUSELS/26/1.webp",
    slides: ["/work/CAROUSELS/26/1.webp", "/work/CAROUSELS/26/6.webp"],
    images: ["/work/CAROUSELS/26/1.webp"],
    description:
      "A high-energy promotional carousel for Pulse Gym Shop's Black Month sale on cardio equipment - up to 70% off. A dark collage features people on treadmills and bikes alongside brand logos (Schwinn, StarMaster). The promotion banner ticker format and bold type create urgency, targeting gym owners and fitness enthusiasts shopping for equipment.",
    services: ["Graphic Design", "Meta Ads", "Copywriting"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c27",
    slug: "carousel-27",
    type: "carousel",
    title: "Dongfeng Shine - Merry Christmas",
    client: "Салина × Dongfeng",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/27/1.webp",
    coverImage: "/work/CAROUSELS/27/1.webp",
    slides: ["/work/CAROUSELS/27/1.webp", "/work/CAROUSELS/27/3.webp"],
    images: ["/work/CAROUSELS/27/1.webp"],
    description:
      "A festive seasonal brand post for Салина's Dongfeng range. A CGI Christmas scene places the red Dongfeng Shine in front of a snow-covered house with fairy lights and a Christmas tree. The warm holiday visual humanises the brand and maintains audience connection during the holiday season without a hard sell.",
    services: [
      "Seasonal Campaign",
      "Graphic Design",
      "Social Media Management",
    ],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "c28",
    slug: "carousel-28",
    type: "carousel",
    title: "Dongfeng - Christmas Model Ornaments",
    client: "Салина × Dongfeng",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/28/1.webp",
    coverImage: "/work/CAROUSELS/28/1.webp",
    slides: [
      "/work/CAROUSELS/28/1.webp",
      "/work/CAROUSELS/28/2.webp",
      "/work/CAROUSELS/28/3.webp",
      "/work/CAROUSELS/28/4.webp",
      "/work/CAROUSELS/28/5.webp",
    ],
    images: ["/work/CAROUSELS/28/1.webp"],
    description:
      "A festive carousel for the Салина × Dongfeng showroom that turns the model line-up into Christmas-tree ornaments - BOX, S7, V9 and more hang among glowing fairy lights and pine branches, each model name rendered as a sparkling bauble. A seasonal brand moment that keeps the whole range top of mind during the holiday buying period.",
    services: [
      "Seasonal Campaign",
      "Graphic Design",
      "Social Media Management",
    ],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "c29",
    slug: "carousel-29",
    type: "carousel",
    title: "Fine Design - Christmas Renovation Discount",
    client: "Fine Design",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/29/1.webp",
    coverImage: "/work/CAROUSELS/29/1.webp",
    slides: ["/work/CAROUSELS/29/1.webp", "/work/CAROUSELS/29/2.webp"],
    images: ["/work/CAROUSELS/29/1.webp"],
    description:
      "A seasonal conversion carousel for Fine Design offering tiered Christmas discounts on renovation services. Split renders of luxury dining rooms, living rooms and bedrooms are presented in a pink and white palette, with discount bands (5–10% on design, 7–12% on full build) and a concrete savings example of €390 to drive direct enquiries.",
    services: ["Content Creation", "Graphic Design", "Copywriting"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c30",
    slug: "carousel-30",
    type: "carousel",
    title: "Fox Academy - PMU Base Course Announcement",
    client: "Fox Academy by Gera",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/30/1.webp",
    coverImage: "/work/CAROUSELS/30/1.webp",
    slides: ["/work/CAROUSELS/30/1.webp", "/work/CAROUSELS/30/4.webp"],
    images: ["/work/CAROUSELS/30/1.webp"],
    description:
      "A course launch carousel for Fox Academy's PMU (Permanent Makeup) base training programme covering lips and eyebrows. Dark glamour aesthetic with gold wave ornaments frames the trainer photo in a glowing pink circle, with dates (28.04–01.05, Sofia) prominently displayed - targeting aspiring PMU artists and driving course bookings.",
    services: ["Graphic Design", "Event Marketing", "Social Media Management"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c31",
    slug: "carousel-31",
    type: "carousel",
    title: "Pulse Homes - Why 2025 Is the Time to Invest",
    client: "Pulse Homes",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/31/1.webp",
    coverImage: "/work/CAROUSELS/31/1.webp",
    slides: [
      "/work/CAROUSELS/31/1.webp",
      "/work/CAROUSELS/31/2.webp",
      "/work/CAROUSELS/31/3.webp",
      "/work/CAROUSELS/31/4.webp",
      "/work/CAROUSELS/31/5.webp",
      "/work/CAROUSELS/31/6.webp",
      "/work/CAROUSELS/31/7.webp",
    ],
    images: ["/work/CAROUSELS/31/1.webp"],
    description:
      'An investment pitch carousel for Pulse Homes targeting property buyers in 2025. A split layout pairs the dark blue branded panel with a CGI luxury apartment building and pool. Gold accent typography reinforces the premium feel while the hook - "Discover why now is the time to invest" - positions the developer as a market-savvy advisor.',
    services: ["Real Estate Marketing", "Graphic Design", "Content Creation"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c32",
    slug: "carousel-32",
    type: "carousel",
    title: "Pulse Gym Shop - Premium Pilates Equipment",
    client: "Pulse Gym Shop",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/32/1.webp",
    coverImage: "/work/CAROUSELS/32/1.webp",
    slides: ["/work/CAROUSELS/32/1.webp", "/work/CAROUSELS/32/2.webp"],
    images: ["/work/CAROUSELS/32/1.webp"],
    description:
      'A B2B sales carousel for Pulse Gym Shop targeting studio owners and sport facility managers. Four premium pilates reformers are displayed with BGN/EUR pricing against a dark moody studio background. The pitch - "The best pilates equipment for your sports facility" - speaks directly to facility buyers rather than individual consumers.',
    services: [
      "B2B Content Creation",
      "Graphic Design",
      "Social Media Management",
    ],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c33",
    slug: "carousel-33",
    type: "carousel",
    title: "Pulse Homes - If You Wait for the Perfect Moment",
    client: "Pulse Homes",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/33/1.webp",
    coverImage: "/work/CAROUSELS/33/1.webp",
    slides: [
      "/work/CAROUSELS/33/1.webp",
      "/work/CAROUSELS/33/2.webp",
      "/work/CAROUSELS/33/3.webp",
      "/work/CAROUSELS/33/4.webp",
      "/work/CAROUSELS/33/5.webp",
    ],
    images: ["/work/CAROUSELS/33/1.webp"],
    description:
      'A FOMO-driven persuasion carousel for Pulse Homes using a dramatic dusk luxury villa with pool as backdrop. The bold text overlay - "If you wait for the perfect moment to invest in property, you\'ll wait forever" - uses red strikethrough and circle annotations for emphasis, nudging hesitant buyers to act rather than delay.',
    services: ["Copywriting", "Graphic Design", "Real Estate Marketing"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c34",
    slug: "carousel-34",
    type: "carousel",
    title: "Pulse Homes - Bulgarian Property Market 2025",
    client: "Pulse Homes",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/34/1.webp",
    coverImage: "/work/CAROUSELS/34/1.webp",
    slides: [
      "/work/CAROUSELS/34/1.webp",
      "/work/CAROUSELS/34/2.webp",
      "/work/CAROUSELS/34/3.webp",
      "/work/CAROUSELS/34/4.webp",
      "/work/CAROUSELS/34/5.webp",
      "/work/CAROUSELS/34/6.webp",
    ],
    images: ["/work/CAROUSELS/34/1.webp"],
    description:
      'An authoritative market-education carousel for Pulse Homes on the Bulgarian property landscape in 2025. A dark handshake photo anchors bold italic copy: "What you need to know about the property market in Bulgaria in 2025?" - teasing 5 key changes. Designed to attract serious investors and build the developer\'s credibility as a market authority.',
    services: ["Content Creation", "Copywriting", "Graphic Design"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "c35",
    slug: "carousel-35",
    type: "carousel",
    title: "Yogamind - Shining Goddess Wellness Programme",
    client: "Yogamind with Dani",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/35/1.webp",
    coverImage: "/work/CAROUSELS/35/1.webp",
    slides: [
      "/work/CAROUSELS/35/1.webp",
      "/work/CAROUSELS/35/2.webp",
      "/work/CAROUSELS/35/3.webp",
      "/work/CAROUSELS/35/4.webp",
      "/work/CAROUSELS/35/5.webp",
      "/work/CAROUSELS/35/6.webp",
    ],
    images: ["/work/CAROUSELS/35/1.webp"],
    description:
      'A programme reveal carousel for the "Shining Goddess" yoga and wellness course by Yogamind. Soft pink AI-generated dreamy landscapes frame a goddess figure at top, while the creator\'s real photo anchors the bottom. The feminine, spiritual aesthetic asks "What will you get from the programme?" - building desire through transformation imagery.',
    services: ["Brand Identity", "Graphic Design", "Content Creation"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c36",
    slug: "carousel-36",
    type: "carousel",
    title: "Christian Andon - Marc Jacobs Lola Decants",
    client: "Christian Andon Fragrances",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/36/20.webp",
    coverImage: "/work/CAROUSELS/36/20.webp",
    slides: [
      "/work/CAROUSELS/36/20.webp",
      "/work/CAROUSELS/36/38.webp",
      "/work/CAROUSELS/36/39.webp",
      "/work/CAROUSELS/36/44.webp",
    ],
    images: ["/work/CAROUSELS/36/20.webp"],
    description:
      "A luxury fragrance editorial carousel for Christian Andon's Marc Jacobs Lola decant collection. A surreal fantasy landscape with topiary animals, an angel statue and roses frames the bottle centred. Notes (Pink Pepper, Rose, Peony) and decant sizes (2ml–10ml) are listed in an aesthetic that blurs editorial fashion and perfume advertising.",
    services: ["Art Direction", "Graphic Design", "Meta Ads"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c37",
    slug: "carousel-37",
    type: "carousel",
    title: "Christian Andon - Fragrance Review Spotlight",
    client: "Christian Andon Fragrances",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/37/6.webp",
    coverImage: "/work/CAROUSELS/37/6.webp",
    slides: ["/work/CAROUSELS/37/6.webp", "/work/CAROUSELS/37/12.webp"],
    images: ["/work/CAROUSELS/37/6.webp"],
    description:
      'A social proof carousel for Christian Andon Fragrances spotlighting a real customer review. A dark luxury background frames a perfume bottle alongside a 5-star testimonial from "Anna Lilova" - a verified buyer detailing her experience with the decant service. Built to convert hesitant new customers through authentic peer validation.',
    services: ["Social Media Management", "Graphic Design", "Copywriting"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c38",
    slug: "carousel-38",
    type: "carousel",
    title: "Pulse Padel - Ready Business in 7–10 Days",
    client: "Pulse Padel",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/38/1.webp",
    coverImage: "/work/CAROUSELS/38/1.webp",
    slides: [
      "/work/CAROUSELS/38/1.webp",
      "/work/CAROUSELS/38/2.webp",
      "/work/CAROUSELS/38/3.webp",
      "/work/CAROUSELS/38/4.webp",
      "/work/CAROUSELS/38/5.webp",
      "/work/CAROUSELS/38/6.webp",
    ],
    images: ["/work/CAROUSELS/38/1.webp"],
    description:
      'A B2B investment pitch carousel for Pulse Padel\'s turnkey court installation business. Aerial and ground-level views of blue padel courts anchor the bold proposition: "PADEL COURT - Ready business in 7–10 days." A green badge and BFP certification callout add credibility for franchise investors looking for a proven, fast-ROI sport business model.',
    services: ["B2B Marketing", "Graphic Design", "Meta Ads"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c39",
    slug: "carousel-39",
    type: "carousel",
    title: "Pulse Padel - Earn From Day One",
    client: "Pulse Padel",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/39/1.webp",
    coverImage: "/work/CAROUSELS/39/1.webp",
    slides: [
      "/work/CAROUSELS/39/1.webp",
      "/work/CAROUSELS/39/2.webp",
      "/work/CAROUSELS/39/3.webp",
      "/work/CAROUSELS/39/4.webp",
      "/work/CAROUSELS/39/5.webp",
    ],
    images: ["/work/CAROUSELS/39/1.webp"],
    description:
      "A lead-generation carousel for Pulse Padel's business opportunity. A close-up of padel balls against a net opens with the hook: \"Want a modern business that earns from day one? We have the solution!\" The green accent palette reflects the sport's identity while the benefit-forward copy attracts aspiring entrepreneurs looking for turnkey sport business models.",
    services: [
      "B2B Content Creation",
      "Graphic Design",
      "Social Media Management",
      "Copywriting",
    ],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "c40",
    slug: "carousel-40",
    type: "carousel",
    title: "Pulse Gym Shop - New Active Gym Pilates Line",
    client: "Pulse Gym Shop",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/40/5.webp",
    coverImage: "/work/CAROUSELS/40/5.webp",
    slides: [
      "/work/CAROUSELS/40/5.webp",
      "/work/CAROUSELS/40/6.webp",
      "/work/CAROUSELS/40/7.webp",
      "/work/CAROUSELS/40/17.webp",
      "/work/CAROUSELS/40/32.webp",
    ],
    images: ["/work/CAROUSELS/40/5.webp"],
    description:
      'A new product announcement carousel for Pulse Gym Shop\'s Active Gym brand pilates range. A studio shot of a woman on a reformer anchors the clean, bold announcement - "NEW PRODUCT! PILATES EQUIPMENT." - alongside the website URL. Simple, direct product awareness designed to reach existing customers and drive traffic to the online shop.',
    services: ["Art Direction", "Graphic Design", "Social Media Management"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "c42",
    slug: "carousel-42",
    type: "carousel",
    title: "El Shisha Diamond - New Arrival Photo Grid",
    client: "El Shisha Diamond",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/42/photo-grid-12-09-2023-03-06-00-0.webp",
    coverImage: "/work/CAROUSELS/42/photo-grid-12-09-2023-03-06-00-0.webp",
    slides: [
      "/work/CAROUSELS/42/photo-grid-12-09-2023-03-06-00-0.webp",
      "/work/CAROUSELS/42/photo-grid-12-09-2023-03-06-00-1.webp",
      "/work/CAROUSELS/42/photo-grid-12-09-2023-03-06-00-2.webp",
    ],
    images: ["/work/CAROUSELS/42/photo-grid-12-09-2023-03-06-00-0.webp"],
    description:
      "A new arrival announcement for El Shisha Diamond using a wine-inspired lifestyle backdrop. The houndstooth edition vape is styled alongside a wine glass, leaning into the premium gifting occasion angle. Specs (0% nicotine, 2500+ puffs) are woven into the visual to inform while the aesthetic seduces.",
    services: ["Art Direction", "Social Media Management", "Graphic Design"],
    goal: "Awareness",
    year: "2023",
  },
  {
    id: "c43",
    slug: "carousel-43",
    type: "carousel",
    title: "The Biohackers with the Best Results Started This Way",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/43/1.webp",
    coverImage: "/work/CAROUSELS/43/1.webp",
    slides: [
      "/work/CAROUSELS/43/1.webp",
      "/work/CAROUSELS/43/2.webp",
      "/work/CAROUSELS/43/3.webp",
      "/work/CAROUSELS/43/4.webp",
      "/work/CAROUSELS/43/5.webp",
    ],
    images: ["/work/CAROUSELS/43/1.webp"],
    description:
      'Built around the hook "Three habits. Zero equipment. No excuses." - each slide reveals one biohacking habit (sleep, sunlight, breathwork) before the final slide introduces the NMN strip as habit #4. A product sell wrapped inside genuinely useful content.',
    services: [
      "Hook-Based Copywriting",
      "Content Creation",
      "Art Direction",
      "Graphic Design",
    ],
    goal: "Engagement",
    year: "2025",
  },
];

// ─── Visuals (category: Designs) ─────────────────────────────────────────────

const visuals: Project[] = [
  {
    id: "v19",
    slug: "sallina-green-mobility",
    type: "carousel",
    title: "Sallina - Green Mobility Special Offers",
    client: "Sallina | Dongfeng & Hongqi",
    category: "Visual",
    thumbnail: "/work/CAROUSELS/52/1.webp",
    coverImage: "/work/CAROUSELS/52/1.webp",
    slides: [
      "/work/CAROUSELS/52/1.webp",
      "/work/CAROUSELS/52/2.webp",
      "/work/CAROUSELS/52/3.webp",
      "/work/CAROUSELS/52/4.webp",
      "/work/CAROUSELS/52/5.webp",
      "/work/CAROUSELS/52/6.webp",
    ],
    images: ["/work/CAROUSELS/52/1.webp"],
    description:
      "A six-post \"Green Mobility\" campaign for Salina Plovdiv's electrified Dongfeng, M-HERO and Forthing models. It opens on the full line-up in front of the showroom, sums up the three offers on one post, gives the Dongfeng BOX, M-HERO 817 and Forthing range a post each with price and gift, and closes with a test-drive invitation - all with a validity date and direct contact details.",
    services: ["Graphic Design", "Social Media Content"],
    goal: "Sales",
    year: "2026",
  },
  {
    id: "v20",
    slug: "coolfit-website-launch",
    type: "image",
    title: "CoolFit - New Website Launch",
    client: "CoolFit",
    category: "Visual",
    thumbnail: "/work/VISUAL/coolfit/website-launch.webp",
    coverImage: "/work/VISUAL/coolfit/website-launch.webp",
    images: ["/work/VISUAL/coolfit/website-launch.webp"],
    description:
      "An announcement post for the updated coolfit.bg. Laptop, tablet and phone mockups of the new site sit on CoolFit's signature blue, with three callouts - faster access to venues, an interactive modern design and a better user experience - and a clear link to explore it.",
    services: ["Social Media Management", "Graphic Design", "Copywriting"],
    goal: "Awareness",
    year: "2026",
  },
  {
    id: "v1",
    slug: "visual-1",
    type: "image",
    title: "Smart Strips - Take What You Need",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/1.webp",
    coverImage: "/work/VISUAL/1.webp",
    images: ["/work/VISUAL/1.webp"],
    description:
      'A brand lifestyle post for Smart Strips presenting wellness strips like a cocktail menu - benefit labels (Good Sleep, Calm Mind, Glowing Skin) fanned out like paper strips over cocktail glasses. The copy "take what you need, but you deserve it all" makes the brand feel accessible and indulgent rather than clinical.',
    services: ["Graphic Design", "Brand Storytelling"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "v2",
    slug: "visual-2",
    type: "image",
    title: "Smart Strips - New to Biohacking?",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/12.webp",
    coverImage: "/work/VISUAL/12.webp",
    images: ["/work/VISUAL/12.webp"],
    description:
      "An acquisition-focused brand post for Smart Strips targeting beginners in the biohacking space. An extreme close-up of a woman's face with a strip on her tongue anchors the bold hook: \"New to BIOHACKING? We've got you covered.\" The provocative editorial style lowers the barrier to entry while keeping the brand's edgy, fashion-forward identity intact.",
    services: ["Copywriting", "Graphic Design", "Social Media Management"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "v3",
    slug: "visual-3",
    type: "image",
    title: "El Shisha Diamond - Vanilla Latte Edition",
    client: "El Shisha Diamond",
    category: "Visual",
    thumbnail: "/work/VISUAL/26.webp",
    coverImage: "/work/VISUAL/26.webp",
    images: ["/work/VISUAL/26.webp"],
    description:
      'A vibrant product post for El Shisha Diamond\'s Vanilla Latte flavour vape. Two marble-finish devices are displayed against a warm pink-orange gradient with the tagline "So good, it must be El Shisha Diamond." A specs bar highlights key features (0% nicotine, 2500 puffs) in a fun, consumer-friendly format that drives impulse discovery.',
    services: ["Graphic Design", "Product Marketing"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "v4",
    slug: "visual-4",
    type: "image",
    title: "El Shisha Diamond - Aloe Grape Ice Edition",
    client: "El Shisha Diamond",
    category: "Visual",
    thumbnail: "/work/VISUAL/31.webp",
    coverImage: "/work/VISUAL/31.webp",
    images: ["/work/VISUAL/31.webp"],
    description:
      'A product flavour post for El Shisha Diamond\'s Aloe Grape Ice vape. Matte black devices sit against a blue-purple-teal gradient that mirrors the cool, refreshing flavour profile. The tagline "So fresh, it must be El Shisha Diamond" keeps brand voice consistent while the colour story communicates the sensory experience before the first puff.',
    services: ["Art Direction", "Graphic Design", "Social Media Management"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "v5",
    slug: "visual-5",
    type: "image",
    title: "El Shisha Diamond - Watermelon Ice Launch",
    client: "El Shisha Diamond",
    category: "Visual",
    thumbnail: "/work/VISUAL/48E9E8E0-527B-43E7-AC16-C34306E664EB.webp",
    coverImage: "/work/VISUAL/48E9E8E0-527B-43E7-AC16-C34306E664EB.webp",
    images: ["/work/VISUAL/48E9E8E0-527B-43E7-AC16-C34306E664EB.webp"],
    description:
      "A fresh product launch post for El Shisha Diamond's Watermelon Ice flavour. The red device sits on a pedestal surrounded by stacked watermelon slices and scattered mint leaves, creating a flavour-matching colour palette of red, green and white. The visual communicates the taste experience purely through ingredients - no explanation needed.",
    services: ["Graphic Design", "Art Direction"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "v6",
    slug: "visual-6",
    type: "image",
    title: "El Cigarro - Watermelon Ice Lifestyle Post",
    client: "El Shisha",
    category: "Visual",
    thumbnail: "/work/VISUAL/B142A41F-0AEB-4F70-9CC6-858976373E8B.webp",
    coverImage: "/work/VISUAL/B142A41F-0AEB-4F70-9CC6-858976373E8B.webp",
    images: ["/work/VISUAL/B142A41F-0AEB-4F70-9CC6-858976373E8B.webp"],
    description:
      'A premium lifestyle post for El Shisha\'s El Cigarro flavoured cigar line. Dark, moody photography of cigars in a wicker basket uses warm amber tones to evoke sophistication. The handwritten "Watermelon Ice" script in white at the bottom-right creates a deliberate tension between the earthy, old-world visual and the playful modern flavour.',
    services: ["Graphic Design", "Brand Identity"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "v7",
    slug: "visual-property-sale",
    type: "image",
    title: "Pulse Homes - Lifestyle Property Portfolio",
    client: "Pulse Homes",
    category: "Visual",
    thumbnail:
      "/work/VISUAL/Black Gold Elegant Property Sale Instagram Post (Instagram Post (45)).webp",
    coverImage:
      "/work/VISUAL/Black Gold Elegant Property Sale Instagram Post (Instagram Post (45)).webp",
    images: [
      "/work/VISUAL/Black Gold Elegant Property Sale Instagram Post (Instagram Post (45)).webp",
    ],
    description:
      "A brand statement post for Pulse Homes presenting their full property portfolio - residential blocks, a hotel and the Pulse Therme spa resort - in a bold dark-panel, gold-headline layout. The positioning line \"Ние не продаваме жилища, а начин на живот!\" (We don't sell homes, we sell a lifestyle) anchors the developer's premium brand identity.",
    services: ["Brand Identity", "Graphic Design", "Real Estate Marketing"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "v9",
    slug: "visual-real-estate-corporate",
    type: "image",
    title: "Pulse Homes - Novus Wellplex Reveal",
    client: "Pulse Homes",
    category: "Visual",
    thumbnail:
      "/work/VISUAL/Blue and White Bold Corporate Real Estate Marketing Instagram Post.webp",
    coverImage:
      "/work/VISUAL/Blue and White Bold Corporate Real Estate Marketing Instagram Post.webp",
    images: [
      "/work/VISUAL/Blue and White Bold Corporate Real Estate Marketing Instagram Post.webp",
    ],
    description:
      "A clean architectural reveal post for the Pulse Novus Wellplex residential complex - featuring 41 apartments, an on-site fitness centre and spa. Three amenity icons accompany the render against a clear blue-sky backdrop, with address and key features listed below. Designed to attract buyers who prioritise wellness infrastructure alongside their home purchase.",
    services: ["Real Estate Marketing", "Graphic Design", "Meta Ads"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "v10",
    slug: "visual-real-estate-elegant",
    type: "image",
    title: "Pulse Homes - Therme Villas at Grand Therme",
    client: "Pulse Homes",
    category: "Visual",
    thumbnail:
      "/work/VISUAL/Blue and Yellow Modern Elegant Real Estate Marketing Instagram Post.webp",
    coverImage:
      "/work/VISUAL/Blue and Yellow Modern Elegant Real Estate Marketing Instagram Post.webp",
    images: [
      "/work/VISUAL/Blue and Yellow Modern Elegant Real Estate Marketing Instagram Post.webp",
    ],
    description:
      "A resort property post for Pulse Homes' Therme Villas at Grand Therme Resort near Bansko. A twilight-blue mood render of a luxury villa with pool is paired with a minimalist icon row of amenities and the website URL - an understated, elegantly composed post that sells the lifestyle of resort ownership rather than listing specifications.",
    services: ["Graphic Design", "Real Estate Marketing"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "v11",
    slug: "visual-11",
    type: "image",
    title: "El Shisha Privé - Luxury Experience Post",
    client: "El Shisha",
    category: "Visual",
    thumbnail: "/work/VISUAL/CD575892-AEE4-4DCB-8859-32128C37A02B.webp",
    coverImage: "/work/VISUAL/CD575892-AEE4-4DCB-8859-32128C37A02B.webp",
    images: ["/work/VISUAL/CD575892-AEE4-4DCB-8859-32128C37A02B.webp"],
    description:
      'A brand awareness post for the El Shisha Privé premium line. Dark editorial design with large serif typography - "Luxury Experience to Remember" - overlays a blurred product and jewellery flat lay, deliberately evoking a high-end perfume advertisement. The absence of hard product details reinforces exclusivity and aspirational desirability.',
    services: ["Brand Identity", "Art Direction", "Graphic Design"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "v12",
    slug: "visual-12",
    type: "image",
    title: "El Shisha Privé - Customer Review Card",
    client: "El Shisha",
    category: "Visual",
    thumbnail: "/work/VISUAL/E5838A2B-0CED-4844-B917-42F6AAD96D3E.webp",
    coverImage: "/work/VISUAL/E5838A2B-0CED-4844-B917-42F6AAD96D3E.webp",
    images: ["/work/VISUAL/E5838A2B-0CED-4844-B917-42F6AAD96D3E.webp"],
    description:
      'A social proof post for El Shisha Privé featuring a UGC-style testimonial card. Reviewer "Gloria Mitova" with a profile photo shares her experience alongside a lifestyle photo of the red device on a brunch table, a 5-star rating and a written quote praising its design and flavours - converting fence-sitters through a peer voice rather than brand claims.',
    services: ["Social Media Management", "Graphic Design", "Copywriting"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "v13",
    slug: "visual-fd-reviews",
    type: "image",
    title: "Fine Design - Client Testimonial Spotlight",
    client: "Fine Design",
    category: "Visual",
    thumbnail: "/work/VISUAL/FD Reviews.webp",
    coverImage: "/work/VISUAL/FD Reviews.webp",
    images: ["/work/VISUAL/FD Reviews.webp"],
    description:
      'A trust-building testimonial post for Fine Design interior studio. A split layout pairs the "Отзиви от наши клиенти" (Reviews from our clients) headline, 5-star rating and a full client quote (Maria Dimitrova) with a luxury fireplace and marble-wall render on the right - anchoring the review in the tangible quality of the finished work.',
    services: ["Social Media Management", "Graphic Design"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "v14",
    slug: "visual-fd-magazine",
    type: "image",
    title: "Fine Design - Featured in Градът Magazine",
    client: "Fine Design",
    category: "Visual",
    thumbnail: "/work/VISUAL/FD magazine design - градът.webp",
    coverImage: "/work/VISUAL/FD magazine design - градът.webp",
    images: ["/work/VISUAL/FD magazine design - градът.webp"],
    description:
      'A press feature announcement post for Fine Design celebrating their coverage in "Градът" - Bulgaria\'s leading architecture and design magazine. Magazine cover and spread mockups are shown with the headline "Creativity and precision in every detail," transforming a media mention into credibility-building social content for the brand\'s audience.',
    services: ["PR Content", "Graphic Design", "Social Media Management"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "v15",
    slug: "visual-fd-departments",
    type: "image",
    title: "Fine Design - Meet the Interior Design Team",
    client: "Fine Design",
    category: "Visual",
    thumbnail: "/work/VISUAL/FD Отдели POST.webp",
    coverImage: "/work/VISUAL/FD Отдели POST.webp",
    images: ["/work/VISUAL/FD Отдели POST.webp"],
    description:
      'A team introduction post for Fine Design\'s Interior Design department. Five professionals are presented in studio portraits arranged in a dynamic diagonal composition on a dark purple/magenta branded background, with the tagline "Запознайте се с отдел Интериорен дизайн" - humanising the brand and building client confidence through faces, not just renders.',
    services: ["Brand Identity", "Graphic Design", "Social Media Management"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "v16",
    slug: "visual-fantastico",
    type: "image",
    title: "El Shisha Diamond - Full Product Line Overview",
    client: "El Shisha Diamond",
    category: "Visual",
    thumbnail: "/work/VISUAL/Fantastico (50 x 70 cm).webp",
    coverImage: "/work/VISUAL/Fantastico (50 x 70 cm).webp",
    images: ["/work/VISUAL/Fantastico (50 x 70 cm).webp"],
    description:
      "A clean product range poster for El Shisha Diamond displaying 6 device colour variants on a tiered white platform, with fruits and herbs suggesting the available flavours. Key specs (0% nicotine, 2500+ puffs, mesh coil, 5ml liquid) are highlighted alongside the website URL - a comprehensive range overview designed for both social media and retail display.",
    services: ["Graphic Design", "Art Direction", "Product Marketing"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "v17",
    slug: "visual-coolfit-partners",
    type: "image",
    title: "CoolFit - 1 Card, Unlimited Sports",
    client: "CoolFit",
    category: "Visual",
    thumbnail:
      "/work/VISUAL/НОВИ ОБЕКТИ И ПАРТНЬОРИ НА CoolFit (1080 x 1350 px).webp",
    coverImage:
      "/work/VISUAL/НОВИ ОБЕКТИ И ПАРТНЬОРИ НА CoolFit (1080 x 1350 px).webp",
    images: [
      "/work/VISUAL/НОВИ ОБЕКТИ И ПАРТНЬОРИ НА CoolFit (1080 x 1350 px).webp",
    ],
    description:
      "A membership acquisition post for CoolFit's multi-sport subscription card. A bold electric-blue layout features a smartphone mockup showing the app's QR membership screen alongside the stat \"410+ спортни и релакс обекта\" (410+ sports and wellness venues) in impactful typography - leading with scale and convenience to drive sign-ups.",
    services: ["Social Media Management", "Graphic Design", "Copywriting"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "v18",
    slug: "visual-christmas",
    type: "image",
    title: "ElWell - New Year 2026 Brand Greeting",
    client: "ElWell",
    category: "Visual",
    thumbnail: "/work/VISUAL/Честита Коледа!.webp",
    coverImage: "/work/VISUAL/Честита Коледа!.webp",
    images: ["/work/VISUAL/Честита Коледа!.webp"],
    description:
      'A cinematic New Year celebration post for ElWell. Two champagne flutes are toasted against a city skyline with fireworks, the glasses containing subtle holographic motifs (gears, DNA strands) woven into the bubbles. "2026" in gold above connects the festive moment to the brand\'s identity, keeping ElWell top-of-mind as audiences ring in the new year.',
    services: ["Graphic Design", "Social Media Management", "Art Direction"],
    goal: "Engagement",
    year: "2025",
  },
];

// Single Smart Strips feed posts - woven between the visuals above (see `projects`)
// so one brand doesn't fill the top of the grid.
const smartStripsPosts: Project[] = [
  {
    id: "v21",
    slug: "smart-strips-no-more-hangovers",
    type: "image",
    title: "Smart Strips AFTR PARTY - No More Hangovers",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/no-more-hangovers.webp",
    coverImage: "/work/VISUAL/smart-strips/no-more-hangovers.webp",
    images: ["/work/VISUAL/smart-strips/no-more-hangovers.webp"],
    description:
      'A typographic AFTR PARTY post where the words "no more hangovers" are drawn in chrome script between three martini glasses, with the olives and a lemon twist standing in for letters. The sachets float in the gaps - a stylish, cocktail-hour way to say what the product does.',
    services: ["Art Direction", "Graphic Design"],
    goal: "Engagement",
    year: "2026",
  },
  {
    id: "v22",
    slug: "smart-strips-game-changer",
    type: "image",
    title: "Smart Strips - The Game Changer",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/game-changer.webp",
    coverImage: "/work/VISUAL/smart-strips/game-changer.webp",
    images: ["/work/VISUAL/smart-strips/game-changer.webp"],
    description:
      'A fashion-led brand post: a model in a monochrome outfit holds a Smart Strips life ring under the headline "The Game Changer - your lifebelt in the sea of supplements." One strong visual metaphor positions the brand as the way out of supplement overload.',
    services: ["Art Direction", "Copywriting", "Graphic Design"],
    goal: "Awareness",
    year: "2026",
  },
  {
    id: "v23",
    slug: "smart-strips-refuel",
    type: "image",
    title: "Smart Strips REFUEL - Recovery, Redefined",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/refuel.webp",
    coverImage: "/work/VISUAL/smart-strips/refuel.webp",
    images: ["/work/VISUAL/smart-strips/refuel.webp"],
    description:
      'A product post for the REFUEL post-workout strip. The sachet rests inside a split coconut on a tropical beach, with the headline "Refuel. Recovery, redefined." and three proof points - up to 95% bioavailability, 35% faster than capsules and 30% more effective than a pill.',
    services: ["Art Direction", "Copywriting", "Graphic Design"],
    goal: "Sales",
    year: "2026",
  },
  {
    id: "v24",
    slug: "smart-strips-forbes-longevity-forum",
    type: "image",
    title: "Smart Strips - Founder at Forbes Health & Longevity Forum",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/forbes-longevity-forum.webp",
    coverImage: "/work/VISUAL/smart-strips/forbes-longevity-forum.webp",
    images: ["/work/VISUAL/smart-strips/forbes-longevity-forum.webp"],
    description:
      "A speaker announcement for Smart Strips founder Elina Ivanova-Atanasova at the Forbes Health & Longevity Forum 2026 in Hilton Sofia. A clean portrait, the founder and longevity & biohacking specialist titles and the forum branding turn a stage appearance into credibility for the brand.",
    services: ["PR Content", "Graphic Design"],
    goal: "Awareness",
    year: "2026",
  },
  {
    id: "v25",
    slug: "smart-strips-anti-hangover-party",
    type: "image",
    title: "Smart Strips AFTR PARTY - Still Not Taking Anti-Hangover Strips?",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/anti-hangover-party.webp",
    coverImage: "/work/VISUAL/smart-strips/anti-hangover-party.webp",
    images: ["/work/VISUAL/smart-strips/anti-hangover-party.webp"],
    description:
      'A tongue-in-cheek AFTR PARTY post. Two glamorous, doll-like guests in heart-shaped sunglasses pull a disgusted face at a champagne party over the line "Eww! There are still people not taking anti-hangover strips?" - humour and a little social pressure do the selling.',
    services: ["Hook-Based Copywriting", "Art Direction", "Graphic Design"],
    goal: "Engagement",
    year: "2026",
  },
  {
    id: "v26",
    slug: "smart-strips-product-lineup",
    type: "image",
    title: "Smart Strips - Trusted by Pharma, Now in Premium Supplements",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/product-lineup.webp",
    coverImage: "/work/VISUAL/smart-strips/product-lineup.webp",
    images: ["/work/VISUAL/smart-strips/product-lineup.webp"],
    description:
      'A range post showing the NMN, Beauté and Immune boxes on a windowsill above a city at sunset. Hand-drawn callouts tag each benefit - biohacking & longevity, glow from within, daily immune support - under the claim "Oral thin strips. Trusted by pharma. Now in premium supplements."',
    services: ["Art Direction", "Copywriting", "Graphic Design"],
    goal: "Sales",
    year: "2026",
  },
  {
    id: "v27",
    slug: "smart-strips-what-is-a-strip",
    type: "image",
    title: "Smart Strips - What Is a Strip?",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/what-is-a-strip.webp",
    coverImage: "/work/VISUAL/smart-strips/what-is-a-strip.webp",
    images: ["/work/VISUAL/smart-strips/what-is-a-strip.webp"],
    description:
      'A close-up explainer post: a strip placed on the tongue against a blurred city skyline, with the question "What is a strip?" and a one-line answer - a smarter supplement format that dissolves on the tongue and delivers the actives straight into the bloodstream, without the losses of digestion.',
    services: ["Product Education", "Copywriting", "Graphic Design"],
    goal: "Awareness",
    year: "2026",
  },
  {
    id: "v28",
    slug: "smart-strips-room-service",
    type: "image",
    title: "Smart Strips - Room Service for People Who Plan Ahead",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/room-service.webp",
    coverImage: "/work/VISUAL/smart-strips/room-service.webp",
    images: ["/work/VISUAL/smart-strips/room-service.webp"],
    description:
      'A minimalist lifestyle post: a hand hangs a burgundy Smart Strips gift bag on a hotel door handle. The line "Room service for people who plan ahead" puts the strips in a premium travel moment and presents them as a new generation of supplements.',
    services: ["Art Direction", "Copywriting", "Graphic Design"],
    goal: "Awareness",
    year: "2026",
  },
  {
    id: "v29",
    slug: "smart-strips-nmn",
    type: "image",
    title: "Smart Strips NMN - Anti-Aging on a Strip",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/nmn.webp",
    coverImage: "/work/VISUAL/smart-strips/nmn.webp",
    images: ["/work/VISUAL/smart-strips/nmn.webp"],
    description:
      'A black-and-gold product post for NMN - "the most advanced anti-aging support" - pairing a strip on the tongue with the box and three benefit icons (NAD+ energy, longevity and cell repair). A row of format facts at the bottom covers dissolving in seconds, carrying anywhere and high bioavailability.',
    services: ["Product Education", "Graphic Design"],
    goal: "Sales",
    year: "2026",
  },
  {
    id: "v30",
    slug: "smart-strips-weekend-pool",
    type: "image",
    title: "Smart Strips AFTR PARTY - Ready for the Weekend?",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/weekend-pool.webp",
    coverImage: "/work/VISUAL/smart-strips/weekend-pool.webp",
    images: ["/work/VISUAL/smart-strips/weekend-pool.webp"],
    description:
      'A Friday post for AFTR PARTY: champagne pours into two coupes at the edge of a pool, with the box and sachets in front. "Are you ready for the weekend? We\'ve got you covered." lands the product right where the weekend starts.',
    services: ["Art Direction", "Copywriting", "Graphic Design"],
    goal: "Engagement",
    year: "2026",
  },
  {
    id: "v31",
    slug: "smart-strips-pleasurex",
    type: "image",
    title: "Smart Strips PLEASUREX - The Hottest Thing Here",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/pleasurex.webp",
    coverImage: "/work/VISUAL/smart-strips/pleasurex.webp",
    images: ["/work/VISUAL/smart-strips/pleasurex.webp"],
    description:
      'A playful launch post for PLEASUREX, the strip for libido, passion and desire. A red chili pepper and a bikini string on sun-kissed skin frame the box, and the line "The hottest thing here isn\'t the pepper" keeps a sensitive product witty rather than explicit.',
    services: ["Art Direction", "Hook-Based Copywriting", "Graphic Design"],
    goal: "Sales",
    year: "2026",
  },
  {
    id: "v32",
    slug: "smart-strips-in-flight",
    type: "image",
    title: "Smart Strips - In-Flight Takeover",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/in-flight.webp",
    coverImage: "/work/VISUAL/smart-strips/in-flight.webp",
    images: ["/work/VISUAL/smart-strips/in-flight.webp"],
    description:
      "A concept visual set in an aircraft cabin where every seatback screen plays Smart Strips - the logo and a model placing a strip on the tongue. It shows the strips as the travel-ready supplement you can take anywhere, with a campaign that feels bigger than a social post.",
    services: ["Art Direction", "Graphic Design"],
    goal: "Awareness",
    year: "2026",
  },
  {
    id: "v33",
    slug: "smart-strips-hangover-hack",
    type: "image",
    title: "Smart Strips AFTR PARTY - The Best Hangover Hack",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/hangover-hack.webp",
    coverImage: "/work/VISUAL/smart-strips/hangover-hack.webp",
    images: ["/work/VISUAL/smart-strips/hangover-hack.webp"],
    description:
      'A product still of two AFTR PARTY sachets between champagne coupes, one open to reveal the strip. "Consider it the best hangover hack you\'ll ever try" sets up the simple ritual underneath: one strip after drinking, one the next morning.',
    services: ["Art Direction", "Copywriting", "Graphic Design"],
    goal: "Sales",
    year: "2026",
  },
  {
    id: "v34",
    slug: "smart-strips-manager-magazine",
    type: "image",
    title: "Smart Strips - Featured in Мениджър Magazine",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/manager-magazine.webp",
    coverImage: "/work/VISUAL/smart-strips/manager-magazine.webp",
    images: ["/work/VISUAL/smart-strips/manager-magazine.webp"],
    description:
      'A press post announcing the Smart Strips feature in the new issue of Мениджър magazine. The open spread - "The future of longevity is thinner than paper" - shows the founder interview and the product range under the magazine masthead, turning the coverage into proof for the brand\'s audience.',
    services: ["PR Content", "Graphic Design", "Social Media Management"],
    goal: "Awareness",
    year: "2026",
  },
  {
    id: "v35",
    slug: "smart-strips-zoom-in",
    type: "image",
    title: "Smart Strips - Wellness Has a New Format",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/zoom-in.webp",
    coverImage: "/work/VISUAL/smart-strips/zoom-in.webp",
    images: ["/work/VISUAL/smart-strips/zoom-in.webp"],
    description:
      'A minimalist post built on white space: a hand with an ornate gold ring pinches its fingers together under "Zoom in. Wellness has a new format." The strip is almost too thin to see - the point of the post - and the fine print explains why, once you try one, pills stop making sense.',
    services: ["Art Direction", "Copywriting", "Graphic Design"],
    goal: "Awareness",
    year: "2026",
  },
  {
    id: "v36",
    slug: "smart-strips-smartest-order",
    type: "image",
    title: "Smart Strips AFTR PARTY - The Smartest Thing You'll Order",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/smartest-order.webp",
    coverImage: "/work/VISUAL/smart-strips/smartest-order.webp",
    images: ["/work/VISUAL/smart-strips/smartest-order.webp"],
    description:
      'A summer AFTR PARTY post: a woman in a straw hat fans three sachets behind a spritz glass on a sunny terrace. "The smartest thing you\'ll order this week" plays on the drinks menu and presents the strip as recovery after a party.',
    services: ["Art Direction", "Copywriting", "Graphic Design"],
    goal: "Sales",
    year: "2026",
  },
  {
    id: "v37",
    slug: "smart-strips-what-is-a-strip-bg",
    type: "image",
    title: "Smart Strips - What Is a Strip? (Bulgarian)",
    client: "Smart Strips",
    category: "Visual",
    thumbnail: "/work/VISUAL/smart-strips/what-is-a-strip-bg.webp",
    coverImage: "/work/VISUAL/smart-strips/what-is-a-strip-bg.webp",
    images: ["/work/VISUAL/smart-strips/what-is-a-strip-bg.webp"],
    description:
      'A Bulgarian-language explainer for the local feed. Translucent strips lie on dark stone with mint and ice under the question "Какво е стрип?" and a one-line answer: a strip you place on your tongue that dissolves in 30 seconds.',
    services: ["Product Education", "Copywriting", "Graphic Design"],
    goal: "Awareness",
    year: "2026",
  },
];

// ─── Print (category: Print) ──────────────────────────────────────────────────

const prints: Project[] = [
  {
    id: "p7",
    slug: "smart-strips-product-menu",
    type: "print",
    title: "Smart Strips - Product Menu Cards",
    client: "Smart Strips",
    category: "Print",
    thumbnail: "/work/PRINT/smart-strips-menu/1.webp",
    coverImage: "/work/PRINT/smart-strips-menu/1.webp",
    slides: [
      "/work/PRINT/smart-strips-menu/1.webp",
      "/work/PRINT/smart-strips-menu/2.webp",
      "/work/PRINT/smart-strips-menu/3.webp",
      "/work/PRINT/smart-strips-menu/4.webp",
      "/work/PRINT/smart-strips-menu/5.webp",
      "/work/PRINT/smart-strips-menu/6.webp",
      "/work/PRINT/smart-strips-menu/7.webp",
      "/work/PRINT/smart-strips-menu/8.webp",
      "/work/PRINT/smart-strips-menu/9.webp",
      "/work/PRINT/smart-strips-menu/10.webp",
    ],
    images: ["/work/PRINT/smart-strips-menu/1.webp"],
    description:
      "A printed product menu of ten cards in Bulgarian, one per strip - FCKN FIT, REFUEL, Z-z-Zen, Anxiety, NMN, Beauté, AFTR PARTY, PLEASUREX, Focus and Immune. Each card has its own pastel gradient, the sachet and box, callouts for every key ingredient, the result and how to use it - a system that makes the whole range easy to compare at a glance.",
    services: ["Print Design", "Product Education", "Copywriting"],
    goal: "Sales",
    year: "2026",
  },
  {
    id: "p8",
    slug: "hongqi-h9-brochure",
    type: "print",
    title: "Hongqi H9 - Tri-Fold Brochure",
    client: "Салина × Hongqi",
    category: "Print",
    thumbnail: "/work/PRINT/hongqi-h9-brochure/mockup.webp",
    coverImage: "/work/PRINT/hongqi-h9-brochure/mockup.webp",
    slides: [
      "/work/PRINT/hongqi-h9-brochure/mockup.webp",
      "/work/PRINT/hongqi-h9-brochure/outside.webp",
      "/work/PRINT/hongqi-h9-brochure/inside.webp",
    ],
    images: ["/work/PRINT/hongqi-h9-brochure/mockup.webp"],
    description:
      'A tri-fold showroom brochure for the Hongqi H9 flagship sedan at Sallina Plovdiv. The cover sells "the brand\'s flagship - prestige, silence, craftsmanship" over a night city scene; inside, the panels cover who the H9 is for, its advantages and the full technical data, with the Sallina story, the model range and a QR code on the back.',
    services: ["Print Design", "Copywriting", "Graphic Design"],
    goal: "Sales",
    year: "2026",
  },
  {
    id: "p9",
    slug: "dongfeng-t5-evo-brochure",
    type: "print",
    title: "Dongfeng T5 EVO - Tri-Fold Brochure",
    client: "Салина × Dongfeng",
    category: "Print",
    thumbnail: "/work/PRINT/dongfeng-t5-evo-brochure/outside.webp",
    coverImage: "/work/PRINT/dongfeng-t5-evo-brochure/outside.webp",
    slides: [
      "/work/PRINT/dongfeng-t5-evo-brochure/outside.webp",
      "/work/PRINT/dongfeng-t5-evo-brochure/inside.webp",
    ],
    images: ["/work/PRINT/dongfeng-t5-evo-brochure/outside.webp"],
    description:
      'A tri-fold brochure for the Dongfeng T5 EVO, built on the same dark-and-red system as the Hongqi H9 edition. The cover promises "dynamics without compromise - power, style, innovation"; inside are the target driver, interior details, advantages and technical data, and the back carries the Sallina dealership story and the full Dongfeng range.',
    services: ["Print Design", "Copywriting", "Graphic Design"],
    goal: "Sales",
    year: "2026",
  },
  {
    id: "p1",
    slug: "print-1",
    type: "print",
    title: "Face Glow - Wellness Programme Flyer",
    client: "Face Glow",
    category: "Print",
    thumbnail: "/work/PRINT/1.webp",
    coverImage: "/work/PRINT/1.webp",
    images: ["/work/PRINT/1.webp"],
    description:
      "An A4 promotional flyer for the Face Glow face yoga and facial care programme for women. The dusty rose and cream palette features a woman using a gua sha tool alongside a checklist of 4 programme benefits, a motivational quote and a QR code - a tactile touchpoint designed to convert awareness into programme sign-ups at events and via DM.",
    services: ["Print Design", "Brand Identity", "Graphic Design"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "p2",
    slug: "print-2",
    type: "print",
    title: "Face Glow - Coach Profile Print Card",
    client: "Face Glow",
    category: "Print",
    thumbnail: "/work/PRINT/2.webp",
    coverImage: "/work/PRINT/2.webp",
    images: ["/work/PRINT/2.webp"],
    description:
      "A print profile card for wellness coach Dani Lekusheva, introducing her credentials for the Face Glow programme. Her photo, Harvard background, CYT-300 yoga certification, social handles and QR code are laid out in the same rose-cream brand palette as the programme flyer - building personal trust and authority with a cohesive brand system across print touchpoints.",
    services: ["Print Design", "Graphic Design", "Brand Identity"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "p3",
    slug: "print-3",
    type: "print",
    title: "Fine Design - Seasonal Renovation Discount Banner",
    client: "Fine Design",
    category: "Print",
    thumbnail: "/work/PRINT/7.webp",
    coverImage: "/work/PRINT/7.webp",
    images: ["/work/PRINT/7.webp"],
    description:
      'A wide-format landscape print banner for Fine Design\'s seasonal renovation promotion. Two luxury interior renders flank a right panel listing tiered discounts (5–10% off design, 7–12% off full project realisation) with a promo code "FINE" and deadline - a conversion-focused print asset that turns showroom or event visits into booked consultations.',
    services: ["Print Design", "Art Direction", "Graphic Design"],
    goal: "Sales",
    year: "2024",
  },
  {
    id: "p4",
    slug: "print-4",
    type: "print",
    title: "Fine Design - Full Services Overview Print",
    client: "Fine Design",
    category: "Print",
    thumbnail: "/work/PRINT/8.webp",
    coverImage: "/work/PRINT/8.webp",
    images: ["/work/PRINT/8.webp"],
    description:
      "A six-panel mosaic grid print piece for Fine Design showcasing all service categories - interior design, renovation, custom furniture, photo wallpapers, interior consultation and third-party project execution. Each panel combines a room render or project photo with bold magenta service labels, giving prospective clients a complete, visually rich overview of the studio's full offer.",
    services: ["Print Design", "Graphic Design", "Art Direction"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "p5",
    slug: "print-fox-certificate",
    type: "print",
    title: "Fox Academy - PMU Masterclass Certificate",
    client: "Fox Academy",
    category: "Print",
    thumbnail: "/work/PRINT/FOX Academy • Certificate.webp",
    coverImage: "/work/PRINT/FOX Academy • Certificate.webp",
    images: ["/work/PRINT/FOX Academy • Certificate.webp"],
    description:
      "An official completion certificate for Fox Academy's \"Pro Eyeliner Under 1 Hour\" PMU masterclass. The elegant black and gold design features the recipient name in gold calligraphy, trainer Gergana Gogova's photo and signature, and the academy's premium branding - designed to be proudly displayed by graduates and shared on social media as organic proof of credibility.",
    services: ["Print Design", "Brand Identity", "Graphic Design"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "p6",
    slug: "print-makeup-flyer",
    type: "print",
    title: "Face Glow - Spring Rituals Wellness Guide",
    client: "Face Glow",
    category: "Print",
    thumbnail: "/work/PRINT/Red and White Modern Creative Makeup Flyer.webp",
    coverImage: "/work/PRINT/Red and White Modern Creative Makeup Flyer.webp",
    images: ["/work/PRINT/Red and White Modern Creative Makeup Flyer.webp"],
    description:
      'A seasonal A4 wellness guide flyer for Face Glow titled "Пролетни ритуали за сияние и пробуждане" (Spring Rituals for Glow and Awakening). Four skincare rituals - morning tissue activation, lymph drainage, body movement, evening release - are presented with a hero image of the coach and dual QR codes linking to the full programme, bridging print and digital acquisition.',
    services: [
      "Print Design",
      "Copywriting",
      "Brand Identity",
      "Graphic Design",
    ],
    goal: "Sales",
    year: "2024",
  },
];

// ─── AI (category: AI) ───────────────────────────────────────────────────────

const aiProjects: Project[] = [
  // ── Smart Strips AI UGC video series ────────────────────────────────────────
  {
    id: "ai15",
    slug: "ai-smart-strips-aftr-party-sunset",
    type: "ai",
    title: "Smart Strips AFTR PARTY - AI Sunset Terrace Video",
    client: "Smart Strips",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/smart-strips-aftr-party-sunset.webp",
    coverImage: "/work/_previews/AI/AI video/smart-strips-aftr-party-sunset.webp",
    images: ["/work/_previews/AI/AI video/smart-strips-aftr-party-sunset.webp"],
    videoSrc: "/work/AI/AI video/smart-strips-aftr-party-sunset.mp4",
    description:
      "A golden-hour AI video for the Smart Strips AFTR PARTY hangover strip - a model in a white dress lounging on a candle-lit Amalfi-style terrace, wine glass in hand, playfully showing the strip before presenting the box to camera as the sun sets over the sea. Luxury lifestyle UGC produced entirely with generative AI.",
    services: ["AI Video Generation", "UGC-Style Content", "Art Direction"],
    goal: "Awareness",
    year: "2025",
  },
  {
    id: "ai16",
    slug: "ai-smart-strips-pleasurex-sky",
    type: "ai",
    title: "Smart Strips PLEASUREX - AI Summer Portrait Video",
    client: "Smart Strips",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/smart-strips-pleasurex-sky.webp",
    coverImage: "/work/_previews/AI/AI video/smart-strips-pleasurex-sky.webp",
    images: ["/work/_previews/AI/AI video/smart-strips-pleasurex-sky.webp"],
    videoSrc: "/work/AI/AI video/smart-strips-pleasurex-sky.mp4",
    description:
      "A sun-drenched AI portrait video for Smart Strips PLEASUREX - a model in clear glasses and a vintage floral blouse placing the strip on her tongue against a bright summer sky, then revealing the gold sachet. Warm, editorial UGC-style content made with generative AI.",
    services: ["AI Video Generation", "UGC-Style Content", "Product Storytelling"],
    goal: "Engagement",
    year: "2025",
  },
  {
    id: "ai17",
    slug: "ai-smart-strips-focus-studio",
    type: "ai",
    title: "Smart Strips FOCUS - AI Editorial Studio Video",
    client: "Smart Strips",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/smart-strips-focus-studio.webp",
    coverImage: "/work/_previews/AI/AI video/smart-strips-focus-studio.webp",
    images: ["/work/_previews/AI/AI video/smart-strips-focus-studio.webp"],
    videoSrc: "/work/AI/AI video/smart-strips-focus-studio.mp4",
    description:
      "A high-fashion AI studio video for Smart Strips FOCUS - an intense close-up of a model in a leather blazer holding the silver sachet to camera, then pulling back into a composed editorial portrait. Minimal, premium product content produced without a studio shoot.",
    services: ["AI Video Generation", "Art Direction", "Brand Content"],
    goal: "Awareness",
    year: "2025",
  },
  {
    id: "ai18",
    slug: "ai-smart-strips-focus-terrace",
    type: "ai",
    title: "Smart Strips FOCUS - AI Workspace Lifestyle Video",
    client: "Smart Strips",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/smart-strips-focus-terrace.webp",
    coverImage: "/work/_previews/AI/AI video/smart-strips-focus-terrace.webp",
    images: ["/work/_previews/AI/AI video/smart-strips-focus-terrace.webp"],
    videoSrc: "/work/AI/AI video/smart-strips-focus-terrace.mp4",
    description:
      "An AI lifestyle video for Smart Strips FOCUS - a remote worker on a tropical ocean-view terrace takes a strip before diving into work, with the camera settling on the FOCUS box and sachet beside his laptop. Aspirational productivity content created with generative AI.",
    services: ["AI Video Generation", "Lifestyle Content", "Product Placement"],
    goal: "Sales",
    year: "2025",
  },
  {
    id: "ai19",
    slug: "ai-smart-strips-nmn-marina",
    type: "ai",
    title: "Smart Strips NMN - AI Marina Lifestyle Video",
    client: "Smart Strips",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/smart-strips-nmn-marina.webp",
    coverImage: "/work/_previews/AI/AI video/smart-strips-nmn-marina.webp",
    images: ["/work/_previews/AI/AI video/smart-strips-nmn-marina.webp"],
    videoSrc: "/work/AI/AI video/smart-strips-nmn-marina.mp4",
    description:
      "A sunlit AI video for the Smart Strips NMN longevity strip - a silver-haired model at a yacht marina taking the strip and holding the sachet to camera. Targets the active, anti-aging audience with premium Mediterranean lifestyle imagery made entirely with AI.",
    services: ["AI Video Generation", "UGC-Style Content", "Audience Targeting"],
    goal: "Sales",
    year: "2025",
  },
  {
    id: "ai20",
    slug: "ai-smart-strips-immune-beach",
    type: "ai",
    title: "Smart Strips IMMUNE - AI Beach Club Video",
    client: "Smart Strips",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/smart-strips-immune-beach.webp",
    coverImage: "/work/_previews/AI/AI video/smart-strips-immune-beach.webp",
    images: ["/work/_previews/AI/AI video/smart-strips-immune-beach.webp"],
    videoSrc: "/work/AI/AI video/smart-strips-immune-beach.mp4",
    description:
      "A tropical AI video for Smart Strips IMMUNE - a model in a silk headscarf lounging at a palm-fringed beach club, tasting the strip and pushing the IMMUNE box toward the camera. Holiday-ready UGC content produced with generative AI.",
    services: ["AI Video Generation", "UGC-Style Content", "Social Media Content"],
    goal: "Engagement",
    year: "2025",
  },
  {
    id: "ai21",
    slug: "ai-smart-strips-anxiety-portrait",
    type: "ai",
    title: "Smart Strips ANXIETY - AI Golden Hour Portrait Video",
    client: "Smart Strips",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/smart-strips-anxiety-portrait.webp",
    coverImage: "/work/_previews/AI/AI video/smart-strips-anxiety-portrait.webp",
    images: ["/work/_previews/AI/AI video/smart-strips-anxiety-portrait.webp"],
    videoSrc: "/work/AI/AI video/smart-strips-anxiety-portrait.mp4",
    description:
      "A calm, golden-hour AI video for Smart Strips ANXIETY - a freckled model takes the strip, closes her eyes and exhales, visually embodying the product promise: slow down, let go, breathe. Emotive product storytelling made with generative AI.",
    services: ["AI Video Generation", "Product Storytelling", "Art Direction"],
    goal: "Awareness",
    year: "2025",
  },
  {
    id: "ai22",
    slug: "ai-smart-strips-beach-portrait",
    type: "ai",
    title: "Smart Strips - AI Beach Close-Up Video",
    client: "Smart Strips",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/smart-strips-beach-portrait.webp",
    coverImage: "/work/_previews/AI/AI video/smart-strips-beach-portrait.webp",
    images: ["/work/_previews/AI/AI video/smart-strips-beach-portrait.webp"],
    videoSrc: "/work/AI/AI video/smart-strips-beach-portrait.mp4",
    description:
      "A sensual AI beach video for Smart Strips - a freckled model lying on white sand under palm-leaf shadows, showing the dissolving strip in a macro close-up before breaking into a smile. Scroll-stopping product demonstration created entirely with AI.",
    services: ["AI Video Generation", "Product Demonstration", "UGC-Style Content"],
    goal: "Engagement",
    year: "2025",
  },
  {
    id: "ai23",
    slug: "ai-smart-strips-studio-strip",
    type: "ai",
    title: "Smart Strips - AI Street-Style Studio Video",
    client: "Smart Strips",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/smart-strips-strip-studio.webp",
    coverImage: "/work/_previews/AI/AI video/smart-strips-strip-studio.webp",
    images: ["/work/_previews/AI/AI video/smart-strips-strip-studio.webp"],
    videoSrc: "/work/AI/AI video/smart-strips-strip-studio.mp4",
    description:
      "A bold, street-style AI studio video for Smart Strips - a model in oversized sunglasses and denim poses with fisheye energy, cutting to extreme close-ups of the strip on her tongue. Gen-Z-focused content made with generative AI.",
    services: ["AI Video Generation", "Art Direction", "Social Media Content"],
    goal: "Engagement",
    year: "2025",
  },
  // ── Smart Strips AI model campaign ──────────────────────────────────────────
  {
    id: "ai1",
    slug: "ai-smart-strips-model-campaign",
    type: "ai",
    title: "Smart Strips - AI Model Campaign",
    client: "Smart Strips",
    category: "AI",
    thumbnail: "/work/AI/AI images/IMG_0130.webp",
    coverImage: "/work/AI/AI images/IMG_0130.webp",
    images: [
      "/work/AI/AI images/IMG_0130.webp",
      "/work/AI/AI images/IMG_9908.webp",
      "/work/AI/AI images/IMG_9912.webp",
      "/work/AI/AI images/IMG_9920.webp",
      "/work/AI/AI images/IMG_9922.webp",
      "/work/AI/AI images/IMG_9923.webp",
      "/work/AI/AI images/IMG_9930.webp",
      "/work/AI/AI images/IMG_9944.webp",
      "/work/AI/AI images/1.webp",
      "/work/AI/AI images/2.webp",
    ],
    description:
      "A fully AI-generated model photography campaign for Smart Strips. Hyper-realistic editorial portraits - freckled models with oversized sunglasses, tongue-on-strip macro shots, holiday Santa-girl poses - produced without a single studio shoot. Delivered scroll-stopping content at a fraction of traditional production cost.",
    services: ["AI Image Generation", "Art Direction", "Brand Photography"],
    goal: "Awareness",
    year: "2024",
  },
  // ── Smart Strips AI NMN model campaign ──────────────────────────────────────
  {
    id: "ai2",
    slug: "ai-smart-strips-nmn-models",
    type: "ai",
    title: "Smart Strips NMN - AI Editorial Portraits",
    client: "Smart Strips",
    category: "AI",
    thumbnail: "/work/AI/AI images/IMG_0137.webp",
    coverImage: "/work/AI/AI images/IMG_0137.webp",
    images: [
      "/work/AI/AI images/IMG_0137.webp",
      "/work/AI/AI images/IMG_3262.webp",
      "/work/AI/AI images/IMG_3263.webp",
      "/work/AI/AI images/IMG_3264.webp",
      "/work/AI/AI images/IMG_3265.webp",
      "/work/AI/AI images/59.webp",
      "/work/AI/AI images/63.webp",
    ],
    description:
      "AI-generated editorial portraits for the Smart Strips NMN longevity range - featuring a distinguished silver-haired model holding NMN packets, and diverse young models in pool water with the Z-z-Zen sleep strip. Authentic-looking campaign imagery created entirely with generative AI, targeted at two distinct audience segments: anti-aging and recovery.",
    services: ["AI Image Generation", "Art Direction", "Campaign Concept"],
    goal: "Awareness",
    year: "2024",
  },
  // ── Smart Strips AI product stills ──────────────────────────────────────────
  {
    id: "ai3",
    slug: "ai-smart-strips-product-stills",
    type: "ai",
    title: "Smart Strips - AI Product Photography",
    client: "Smart Strips",
    category: "AI",
    thumbnail: "/work/AI/AI images/IMG_4791.webp",
    coverImage: "/work/AI/AI images/IMG_4791.webp",
    images: [
      "/work/AI/AI images/IMG_4791.webp",
      "/work/AI/AI images/IMG_4804.webp",
      "/work/AI/AI images/IMG_4815.webp",
      "/work/AI/AI images/IMG_4831.webp",
      "/work/AI/AI images/IMG_4850.webp",
      "/work/AI/AI images/IMG_5103.webp",
      "/work/AI/AI images/IMG_5154.webp",
      "/work/AI/AI images/IMG_5169.webp",
      "/work/AI/AI images/IMG_5216.webp",
      "/work/AI/AI images/IMG_5247.webp",
      "/work/AI/AI images/IMG_5261.webp",
    ],
    description:
      "Full AI product photography suite for the Smart Strips range - Z-z-Zen on a moonlit silk pillow by the ocean, AftrParty on neon green crushed ice, Anxiety on a Zen sand garden, NMN Immue box in a sunlit forest stream, and Beauté held by an elegant businesswoman. Each product styled with a distinct mood that reinforces its benefit promise.",
    services: [
      "AI Product Photography",
      "Art Direction",
      "Visual Storytelling",
    ],
    goal: "Sales",
    year: "2024",
  },
  // ── Smart Strips AI video campaign ──────────────────────────────────────────
  {
    id: "ai4",
    slug: "ai-smart-strips-videos",
    type: "ai",
    title: "Smart Strips - AI Product Video Reels",
    client: "Smart Strips",
    category: "AI",
    thumbnail: "/work/AI/AI images/IMG_5111.webp",
    coverImage: "/work/AI/AI images/IMG_5111.webp",
    images: ["/work/AI/AI images/IMG_5111.webp"],
    videoSrc:
      "/work/AI/AI video/copy_3D704004-17A8-422C-A84E-5C34C346B8F8 2.mp4",
    description:
      "AI-generated product video reels for Smart Strips - animated scenes with falling rose petals around the PleasureX strip, floating berries and DNA helix around the NMN box, and atmospheric product reveals. High-production-value motion content generated entirely with AI tools for social media and paid ads.",
    services: ["AI Video Generation", "Motion Design", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  // ── El Shisha Diamond AI product stills ─────────────────────────────────────
  {
    id: "ai5",
    slug: "ai-el-shisha-diamond-product-stills",
    type: "ai",
    title: "El Shisha Diamond - AI Product Photography",
    client: "El Shisha Diamond",
    category: "AI",
    thumbnail: "/work/AI/AI images/IMG_7624.webp",
    coverImage: "/work/AI/AI images/IMG_7624.webp",
    images: [
      "/work/AI/AI images/IMG_7624.webp",
      "/work/AI/AI images/IMG_7625.webp",
      "/work/AI/AI images/IMG_7631.webp",
      "/work/AI/AI images/Gemini_Generated_Image_8u2r3j8u2r3j8u2r.webp",
      "/work/AI/AI images/Gemini_Generated_Image_jeaip5jeaip5jeai.webp",
      "/work/AI/AI images/Gemini_Generated_Image_iztb7viztb7viztb.webp",
      "/work/AI/AI images/Gemini_Generated_Image_opue04opue04opue.webp",
      "/work/AI/AI images/Gemini_Generated_Image_r1o14kr1o14kr1o1.webp",
    ],
    description:
      "AI-generated product photography for the El Shisha Diamond premium vape range - the art-print edition at golden hour on an Amalfi Coast marble table beside blood oranges and a wine glass; the watermelon ice variant leaning against a halved watermelon at a resort pool at sunset; the houndstooth edition in a luxury gift box. Lifestyle imagery indistinguishable from real shoots.",
    services: [
      "AI Product Photography",
      "Gemini Image Generation",
      "Art Direction",
    ],
    goal: "Sales",
    year: "2024",
  },
  // ── El Shisha Diamond AI product stills pt2 ─────────────────────────────────
  {
    id: "ai6",
    slug: "ai-el-shisha-diamond-product-stills-2",
    type: "ai",
    title: "El Shisha Diamond - AI Lifestyle Stills",
    client: "El Shisha Diamond",
    category: "AI",
    thumbnail: "/work/AI/AI images/IMG_1358.webp",
    coverImage: "/work/AI/AI images/IMG_1358.webp",
    images: [
      "/work/AI/AI images/IMG_1358.webp",
      "/work/AI/AI images/IMG_1369.webp",
      "/work/AI/AI images/IMG_1372.webp",
      "/work/AI/AI images/IMG_6409.webp",
      "/work/AI/AI images/IMG_6415.webp",
      "/work/AI/AI images/IMG_6421.webp",
      "/work/AI/AI images/IMG_6473.webp",
      "/work/AI/AI images/IMG_6474.webp",
    ],
    description:
      "A second wave of AI lifestyle product photography for El Shisha Diamond - the carbon-fibre edition nestled in champagne ice with gold confetti, gift-wrapped in black velvet with fairy lights, and the black Diamond edition in a cherry martini glass for Valentine's. Each image engineered to fit a specific seasonal campaign or product launch.",
    services: ["AI Image Generation", "Seasonal Campaign", "Art Direction"],
    goal: "Sales",
    year: "2024",
  },
  // ── El Shisha Diamond AI video reels ────────────────────────────────────────
  {
    id: "ai7",
    slug: "ai-el-shisha-diamond-videos",
    type: "ai",
    title: "El Shisha Diamond - AI Video Reels",
    client: "El Shisha Diamond",
    category: "AI",
    thumbnail: "/work/AI/AI images/IMG_6415.webp",
    coverImage: "/work/AI/AI images/IMG_6415.webp",
    images: ["/work/AI/AI images/IMG_6415.webp"],
    description:
      "AI-generated video reels for El Shisha Diamond - the Grinch's furry green hand clutching the emerald device through velvet curtains with falling snow; cinematic product reveal animations. Playful, seasonal, and brand-consistent AI motion content designed to maximise organic reach on Instagram and TikTok.",
    services: [
      "AI Video Generation",
      "Seasonal Campaign",
      "Social Media Content",
    ],
    goal: "Engagement",
    year: "2024",
  },
  // ── Fine Design AI interior walkthroughs ────────────────────────────────────
  {
    id: "ai8",
    slug: "ai-fine-design-interior-walkthroughs",
    type: "ai",
    title: "Fine Design - AI Interior Visualisation Videos",
    client: "Fine Design",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/copy_F5C63566-9841-4155-9A10-C0AE101552D6.webp",
    coverImage: "/work/_previews/AI/AI video/copy_F5C63566-9841-4155-9A10-C0AE101552D6.webp",
    images: ["/work/_previews/AI/AI video/copy_F5C63566-9841-4155-9A10-C0AE101552D6.webp"],
    videoSrc: "/work/AI/AI video/copy_F5C63566-9841-4155-9A10-C0AE101552D6.mp4",
    description:
      "AI-animated interior walkthrough videos for Fine Design - sweeping through a grand double-height living room with a spiral staircase and crystal chandeliers, gliding through a minimal golden-lit bedroom with curved walls and a circular bed, and a Valentine's POV tour of a moody loft dressed with red roses and candles. Cinematic 3D animation produced fully with AI for client pitches and social media.",
    services: ["AI Video Generation", "3D Visualisation", "Interior Marketing"],
    goal: "Awareness",
    year: "2024",
  },
  // ── Fine Design AI design concept video ─────────────────────────────────────
  {
    id: "ai9",
    slug: "ai-fine-design-concept",
    type: "ai",
    title: "Fine Design - AI Design Process Visualisation",
    client: "Fine Design",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/de13b79968f84c27a2132e024a702706.webp",
    coverImage: "/work/_previews/AI/AI video/de13b79968f84c27a2132e024a702706.webp",
    images: ["/work/_previews/AI/AI video/de13b79968f84c27a2132e024a702706.webp"],
    videoSrc: "/work/AI/AI video/de13b79968f84c27a2132e024a702706.mp4",
    description:
      "An AI-generated isometric miniature bedroom model sitting on a designer's desk - surrounded by material swatches, blueprints, a Fine Design branded mug and pencils - brought to life as a motion video. Used as a signature brand content piece conveying the studio's precision design process in a visually arresting, shareable format.",
    services: ["AI Video Generation", "Brand Content", "Art Direction"],
    goal: "Awareness",
    year: "2025",
  },
  // ── Pulse Homes AI property videos ──────────────────────────────────────────
  {
    id: "ai11",
    slug: "ai-pulse-homes-property-videos",
    type: "ai",
    title: "Pulse Homes - AI Property Portfolio Videos",
    client: "Pulse Homes",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/d4fb4f8e95ec45369562bdf584b547a6.webp",
    coverImage: "/work/_previews/AI/AI video/d4fb4f8e95ec45369562bdf584b547a6.webp",
    images: ["/work/_previews/AI/AI video/d4fb4f8e95ec45369562bdf584b547a6.webp"],
    videoSrc: "/work/AI/AI video/d4fb4f8e95ec45369562bdf584b547a6.mp4",
    description:
      "AI-generated video content across the Pulse Homes property portfolio - the Pulse Tower Wellplex glass curtain-wall tower at golden hour, Pulse NOVUS Wellplex at dusk, Pulse PARK Wellplex aerial showcase, and a branded Pulse Homes logo reveal over a dark luxury interior. Multi-property campaign video produced entirely with generative AI for social ads and developer presentations.",
    services: ["AI Video Generation", "Real Estate Marketing", "Brand Video"],
    goal: "Sales",
    year: "2024",
  },
  // ── Pulse Homes AI interior walkthroughs ────────────────────────────────────
  {
    id: "ai12",
    slug: "ai-pulse-homes-interiors",
    type: "ai",
    title: "Pulse Homes - AI Interior Lifestyle Videos",
    client: "Pulse Homes",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/copy_A85D26F9-1E9D-4682-996C-DB40F90FBF33.webp",
    coverImage: "/work/_previews/AI/AI video/copy_A85D26F9-1E9D-4682-996C-DB40F90FBF33.webp",
    images: ["/work/_previews/AI/AI video/copy_A85D26F9-1E9D-4682-996C-DB40F90FBF33.webp"],
    videoSrc: "/work/AI/AI video/copy_A85D26F9-1E9D-4682-996C-DB40F90FBF33.mp4",
    description:
      "AI interior lifestyle videos for Pulse Homes showing finished apartment interiors - a warm open-plan living and dining room with sculptural chandelier and TV wall, a light Scandinavian dining nook with organic pendant lighting, and a romantic blush master bedroom with botanical wall panels. Aspirational interior content that sells the lifestyle of owning a Pulse Homes apartment.",
    services: [
      "AI Video Generation",
      "Interior Marketing",
      "Lifestyle Content",
    ],
    goal: "Awareness",
    year: "2024",
  },
  // ── Dongfeng AI video ────────────────────────────────────────────────────────
  {
    id: "ai13",
    slug: "ai-dongfeng-video",
    type: "ai",
    title: "Салина × Dongfeng - AI Cinematic Car Videos",
    client: "Салина × Dongfeng",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/df00b2cd4e944e4bbded4ba9ec25c82c.webp",
    coverImage: "/work/_previews/AI/AI video/df00b2cd4e944e4bbded4ba9ec25c82c.webp",
    images: ["/work/_previews/AI/AI video/df00b2cd4e944e4bbded4ba9ec25c82c.webp"],
    videoSrc: "/work/AI/AI video/df00b2cd4e944e4bbded4ba9ec25c82c.mp4",
    description:
      "AI-generated cinematic car videos for the Салина × Dongfeng dealership - a white Dongfeng sedan shot from directly above gliding down an autumn road flanked by fiery red and orange trees, and a red Dongfeng SUV charging head-on through a rain-lit city boulevard at night with motion blur. Filmic automotive visuals produced with AI at zero location shoot cost.",
    services: [
      "AI Video Generation",
      "Automotive Marketing",
      "Cinematic Content",
    ],
    goal: "Awareness",
    year: "2024",
  },
  // ── Pulse Homes AI luxury complex videos ─────────────────────────────────────
  {
    id: "ai14",
    slug: "ai-pulse-homes-luxury-complex",
    type: "ai",
    title: "Pulse Homes - AI Luxury Complex Promo",
    client: "Pulse Homes",
    category: "AI",
    thumbnail: "/work/_previews/AI/AI video/553295429d0b442ca8c228b402fe0be7.webp",
    coverImage: "/work/_previews/AI/AI video/553295429d0b442ca8c228b402fe0be7.webp",
    images: ["/work/_previews/AI/AI video/553295429d0b442ca8c228b402fe0be7.webp"],
    videoSrc: "/work/AI/AI video/553295429d0b442ca8c228b402fe0be7.mp4",
    description:
      "AI-generated aerial and walkthrough promo videos for Pulse Homes luxury complex - a bird's-eye view of the lit-up spa and pool complex at night, and a dark premium interior slideshow. Rich, atmospheric AI video content used for paid social campaigns targeting high-net-worth property buyers.",
    services: [
      "AI Video Generation",
      "Real Estate Marketing",
      "Luxury Brand Content",
    ],
    goal: "Sales",
    year: "2024",
  },
];

// ─── Reels (category: Reels) ─────────────────────────────────────────────────

const reels: Project[] = [
  {
    id: "r45",
    slug: "reel-45",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/3e7cdbfd2c0f421db1d7d1fb7334afba.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r46",
    slug: "reel-46",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/74Wtq7NMqnAAS91ofyvf__v4Os6grE.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r47",
    slug: "reel-47",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/828d59bfe4944028afdbba48b33453da.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r48",
    slug: "reel-48",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/Captions_902B59.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r50",
    slug: "reel-50",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/Jh1idB_XW0RBG_wRhw_zH_Hldo84FY.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r51",
    slug: "reel-51",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/Pause to catch it.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r52",
    slug: "reel-52",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/VLkue2gykfcpdRvce2AR5_r9VJT1P1.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r53",
    slug: "reel-53",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/W9hh4CRiLjMsEs-9sR6Dy_ONGVnRE6.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r54",
    slug: "reel-54",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_10A22564-03E1-453E-AE26-0284744AB669.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r55",
    slug: "reel-55",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_3743B8E9-6AFF-453F-8F75-F2C27575C665.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r56",
    slug: "reel-56",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_3D19D6EE-93A9-473A-8CED-3CDE73974AAA.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r57",
    slug: "reel-57",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_51E54A54-CBCC-4CCB-8220-36C05077AD19.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r58",
    slug: "reel-58",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_5E221904-68E7-4506-9AA5-992B998FFE51.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r59",
    slug: "reel-59",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_7CB91762-8DDA-45CF-95F6-F41F1619125F.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r60",
    slug: "reel-60",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_8A4B49DE-7DA5-4ABA-9F1D-59A5F02077AE.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r61",
    slug: "reel-61",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_912F0F65-4631-4F51-B18F-8FA714BF0537.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r62",
    slug: "reel-62",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_9E402A02-EBC1-42F5-88FE-E2426A0FD47E.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r63",
    slug: "reel-63",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_C78CB43E-CBCB-4E24-ACC0-5FE5B3ED327C.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r64",
    slug: "reel-64",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_C9878131-C3FB-4BB8-ACA4-820C459DCF9A.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r65",
    slug: "reel-65",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/sUXZi60Pz_ttwmemlEwNe_abJ8Cnl1.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r66",
    slug: "reel-66",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/tRAdFULnoodW9Cwo0OCvB_lFB18tQ6.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
  },
  {
    id: "r1",
    slug: "reel-1",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/1a81b02227e04e7abb8e1bbad3644760.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r2",
    slug: "reel-2",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/24159e6919994f6893b820297dca9965.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r3",
    slug: "reel-3",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/316321b7e44a45b3941f71a51ab61587.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r4",
    slug: "reel-4",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/338e9235b1a94a4c88217469211e31f6.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r5",
    slug: "reel-5",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/4eae7399dbed407786b8a99310ceb398.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r6",
    slug: "reel-6",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/7fcead913b51433893f18a6e381f5760.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r7",
    slug: "reel-7",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/9055384d7e23433a9894649d235a1201.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r8",
    slug: "reel-8",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/9fc2b9f0167d4dd79a65caec6ea2624d.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r9",
    slug: "reel-9",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/Captions_1E85CD.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r10",
    slug: "reel-10",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/Captions_36502F.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r11",
    slug: "reel-11",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/Captions_BB87BF.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r12",
    slug: "reel-12",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/Captions_BC36F6.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r13",
    slug: "reel-13",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/Captions_C5B157.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r14",
    slug: "reel-14",
    type: "video",
    title: "Reel",
    client: "Fine Design",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/Captions_FF9C57.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r15",
    slug: "reel-15",
    type: "video",
    title: "Pulse Padel - Reel",
    client: "Pulse Padel",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/PH Padel Video.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Awareness",
    year: "2024",
  },
  {
    id: "r16",
    slug: "reel-16",
    type: "video",
    title: "PH Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/PH_Video_08.10.2025.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2025",
  },
  {
    id: "r17",
    slug: "reel-17",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/ab0fcbcff4fe43f68e498c5c2df70720.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r18",
    slug: "reel-18",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/b1bb1ffdccfd47ec8772e55defd9b96d.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r19",
    slug: "reel-19",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/b871004bc91949489d606298f48c7665.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r20",
    slug: "reel-20",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/c1dac08735ef4af3b0965dfa22a56823.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r21",
    slug: "reel-21",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_07E2ACC2-7E5B-4453-BAF5-012BAEF16F77.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r22",
    slug: "reel-22",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_0A29E530-3433-4BDC-9258-E250D3EFD95C.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r23",
    slug: "reel-23",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_1F7F0B98-C781-4F18-BE85-A8FBAB32EC22.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r24",
    slug: "reel-24",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_37D97200-4793-4855-90AD-E34BF5782BDB.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r26",
    slug: "reel-26",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_402C8DF3-5D86-499B-9164-BA6E8989BD91.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r27",
    slug: "reel-27",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_58829B80-5F4F-4E93-9BDB-581C7C2C00FB.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r28",
    slug: "reel-28",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_6DFB87DF-34E1-42CE-8E42-A4BBCF06E035.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r29",
    slug: "reel-29",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_7C97B899-FAD6-420A-8CFA-A9B168DCAED1.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r30",
    slug: "reel-30",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_8BBD86C5-3FF7-4C26-B79F-5FD8FBA0B330.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r31",
    slug: "reel-31",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_9157EB09-48F0-417A-B5A4-D57DC6B34CED.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r32",
    slug: "reel-32",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_AA80E6AE-A20A-4C3A-95EC-1A84B0E181DB.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r33",
    slug: "reel-33",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_B92AD97F-C0CE-486D-88DD-B022A5A8087E.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r34",
    slug: "reel-34",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_C5F779BC-FDC1-4283-924D-3BECB654EC4F.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r35",
    slug: "reel-35",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_E1790485-14AD-4A0F-A193-911B23B97364.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r36",
    slug: "reel-36",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_F0A890C8-68FA-42B5-9FCC-C507D42D687B.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r38",
    slug: "reel-38",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/copy_FEFD8293-9A65-49B5-9597-9BDCC45E9D99 2.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r39",
    slug: "reel-39",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/d41b3ec357484bc788d496fd03addf82.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r43",
    slug: "reel-43",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/f295c000abc44bed939b024cf4669b21.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
  {
    id: "r44",
    slug: "reel-44",
    type: "video",
    title: "Reel",
    client: "Aviva Digital",
    category: "Reels",
    thumbnail: "",
    coverImage: "",
    images: [],
    videoSrc: "/work/REELS/web/f8905ec235f14bc5a0670f734c1ffa72.mp4",
    description: "Short-form video reel produced for social media.",
    services: ["Video Production", "Social Media Content"],
    goal: "Engagement",
    year: "2024",
  },
];

// ─── Exports ──────────────────────────────────────────────────────────────────

function interleave(...groups: Project[][]): Project[] {
  const result: Project[] = [];
  const queues = groups.map((g) => [...g]);
  let i = 0;
  while (queues.some((q) => q.length > 0)) {
    const q = queues[i % queues.length];
    if (q.length > 0) result.push(q.shift()!);
    i++;
  }
  return result;
}

export const projects: Project[] = interleave(
  carousels,
  reels,
  aiProjects,
  interleave(visuals, smartStripsPosts),
  prints,
);

export const projectCategories = [
  "All",
  "Visual",
  "Reels",
  "AI",
  "Print",
] as const;

/** Reels that only carry the generic placeholder copy - near-identical pages, kept out of search. */
export const isGenericReel = (p: Project) =>
  p.description === "Short-form video reel produced for social media.";
